import { useEffect, useMemo, useRef, useState } from "react";
import RegularLoader from "../../../../Component/Loader/RegularLoader";
import { Input } from "./Input";
import PhoneVerifyModal from "./PhoneVerifyModal";
import { useNavigate } from "react-router-dom";
import ImageUpload from "./ImageUpload";
import ImeiScanner from "./ImeiScanner";
import { BrowserMultiFormatReader } from "@zxing/browser";
import toast from "react-hot-toast";
import { scanImeiFromImage } from "./scanImeiFromImage";
import { AlertCircle, AlertTriangle, Camera, Scan, ScanLine, Wallet } from "lucide-react";
import { BASE_URL } from "../../../../config/api";
import { form } from "framer-motion/client";
import { cn } from "../Invoice/invoiceUtils";
import { createPortal } from "react-dom";
import { ValueLoader } from "../../../../Component/Common/ValueLoader";
import { WarrantyPlanGrid } from "./WarrantyPlanGrid";

/* ===============================
   FORM BODY
================================ */
export const FormBody = ({
  currentStep,   
  form,
  errors,
  updateField,
  existingCustomer,
  onSearchModel,
  modelResults = [],
  modelLoading,
  verifiedMobile,
  categories = [],
  categoriesLoading,
  brands,
  priceTemplates = [],
  selectedTemplate,
  setSelectedTemplate,
  noTemplateMessage,
  loading = false,
  onViewTemplates, // ✅ NEW
  onPincodeChange,
  pinLoading,
  handleImageUpload,
  confirmed,
  setConfirmed,
  isPhoneVerified,
  setIsPhoneVerified,
  setCalculatedPayouts,
  paymentConfig,
  loadingPaymentConfig,
  retailer,
  retailerLoading,
  setIsPayLater,
  wCustomerId,
  walletBalance,
  walletLoading,
  onNext,
}) => {

  useEffect(() => {
    if (selectedTemplate && currentStep === 1) {
      onNext(); // 🚀 auto move to next step
    }
  }, [selectedTemplate]);

  console.log("retailer from user id : ", retailer)

  const [showVerify, setShowVerify] = useState(false);
  const Navigate = useNavigate();
  const [showScanner, setShowScanner] = useState(false);
  const [scanTarget, setScanTarget] = useState("deviceImei");
  const [paymentSaving, setPaymentSaving] = useState(false);

  // const [expandAll, setExpandAll] = useState({});
  const [expandAll, setExpandAll] = useState(false);
  const [expandedCoverage, setExpandedCoverage] = useState({});
  const [useWallet, setUseWallet] = useState(false);
  

  const [expanded, setExpanded] = useState({
    features: false,
    coverage: false,
    exclusions: false,
  });


  const [confirmModal, setConfirmModal] = useState({
    open: false,
    type: null,
  });
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [payLaterSelected, setPayLaterSelected] = useState(false);
  

  const [currentIndex, setCurrentIndex] = useState(0);

  const [paymentKeys, setPaymentKeys] = useState({
      key_id: "",
      key_secret: ""
    });

  const [showProfitId, setShowProfitId] = useState(null);
  const [openInfoId, setOpenInfoId] = useState(null);

  const [showSettlement, setShowSettlement] = useState(false);
  
    const [keyLoading, setKeyLoading] = useState(false);

    const scrollRef = useRef(null);

const scrollLeft = () => {
  scrollRef.current?.scrollBy({ left: -350, behavior: "smooth" });
};

const scrollRight = () => {
  scrollRef.current?.scrollBy({ left: 350, behavior: "smooth" });
};

const [direction, setDirection] = useState(0); 

const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");

const isRetailerMobile =
  typeof window !== "undefined" &&
  window.innerWidth < 640 &&
  (authUser?.role === 5 || authUser?.role === 6);

const handleNextCard = () => {
  if (currentIndex < priceTemplates.length - 1) {
    setDirection(1);
    setCurrentIndex((prev) => prev + 1);
  }
};

const handlePrevCard = () => {
  if (currentIndex > 0) {
    setDirection(-1);
    setCurrentIndex((prev) => prev - 1);
  }
};

const effectiveRetailerId =
  Number(retailer?.role) === 6
    ? retailer?.created_by_id
    : retailer?.id;

const effectivePromoterId =
  Number(retailer?.role) === 6
    ? retailer?.id
    : null;

    console.log("effectiveRetailerId: ", effectiveRetailerId)
  const decodeBarcodeFromImage = async (file) => {
  const reader = new BrowserMultiFormatReader();

  const imageUrl = URL.createObjectURL(file);

  try {
    const result = await reader.decodeFromImageUrl(imageUrl);

    const rawText = result.getText();
    const imei = rawText.replace(/\D/g, "");

    if (imei.length < 14 || imei.length > 16) {
      throw new Error("Invalid IMEI barcode");
    }

    return imei;
  } finally {
    URL.revokeObjectURL(imageUrl);
  }
};

  const [modelQuery, setModelQuery] = useState("");
    let debounceTimer;
  
    const MIN_CHARS = 3;

    const handleModelChange = (e) => {
      const value = e.target.value;
      setModelQuery(value);
      updateField("deviceModel", value);

      clearTimeout(debounceTimer);

      debounceTimer = setTimeout(() => {
        if (value.trim().length >= MIN_CHARS) {
          onSearchModel(value.trim());
        } else {
          onSearchModel(""); // 🔥 clear results when less than 3 chars
        }
      }, 400);
    };

  const filteredBrands = useMemo(() => {
  if (!form.category) return [];

  return brands.filter((brand) =>
    brand.categories?.some(
      (cat) => Number(cat.id) === Number(form.category)
    )
  );
}, [brands, form.category]);

  const getExpiryDate = (validityDays) => {
    if (!validityDays) return "";

    const today = new Date();
    const expiry = new Date(today);
    expiry.setDate(today.getDate() + Number(validityDays));

    return expiry.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const product = selectedTemplate?.warranty_product;
  console.log("selectedTemplate: ", selectedTemplate)
  console.log("Product details: ", product)
  const {
    retailerPayout,
    employeePayout,
    otherpayout,
    companypayout,
    devicePrice,
    TotalPayout,
    retailerPending,
    productPrice,
  } = useMemo(() => {
    const isPercent = Number(product?.is_percent) === 1;

    // device price (MOP / selling price)
    const devicePrice = Number(form?.mopPrice || 0);

    // product price (MRP or % of device price)
    const productPrice = isPercent
      ? (Number(product?.mrp || 0) / 100) * devicePrice
      : Number(product?.mrp || 0);

    // payouts
    const retailerPayout = isPercent
      ? (Number(selectedTemplate?.retailer_payout || 0) / 100) * devicePrice
      : Number(selectedTemplate?.retailer_payout || 0);

    const employeePayout = isPercent
      ? (Number(selectedTemplate?.emp_payout || 0) / 100) * devicePrice
      : Number(selectedTemplate?.emp_payout || 0);

    const otherpayout = isPercent
      ? (Number(selectedTemplate?.other_payout || 0) / 100) * devicePrice
      : Number(selectedTemplate?.other_payout || 0);
    
    const companypayout = isPercent
      ? (Number(selectedTemplate?.company_payout || 0) / 100) * devicePrice
      : Number(selectedTemplate?.company_payout || 0);

    // const TotalPayout = retailerPayout + employeePayout
    const TotalPayout = retailerPayout
    // pending for retailer
    const retailerPending = Math.max(
      0,
      productPrice - TotalPayout
    );

    return {
      retailerPayout,
      employeePayout,
      devicePrice,
      companypayout,
      otherpayout,
      retailerPending,
      productPrice,
      TotalPayout,
    };
  }, [selectedTemplate, product, form?.mopPrice]);

    useEffect(() => {
    if (!selectedTemplate) return;

    setCalculatedPayouts({
      retailerPayout,
      employeePayout,
      otherpayout,
      companypayout,
      productPrice,
      retailerPending
    });
  }, [
    retailerPayout,
    employeePayout,
    productPrice,
    selectedTemplate,
  ]);

  const walletDisabled = walletBalance < retailerPending;

  const features = useMemo(() => {
    const raw = product?.features || "";
    return raw
      .split(".")
      .map((f) => f.trim())
      .filter(Boolean);
  }, [product?.features]);

  const coverage = useMemo(() => {
    const raw = product?.coverage || "";
    return raw
      .split(".")
      .map((c) => c.trim())
      .filter(Boolean);
  }, [product?.coverage]);

  const exclusions = useMemo(() => {
    const raw = product?.exclusions || "";
    return raw
      .split(".")
      .map((e) => e.trim())
      .filter(Boolean);
  }, [product?.exclusions]);

  const paymentButtons = useMemo(() => {
  if (!paymentConfig) {
    return { showPayNow: false, showPayLater: false };
  }

  const {
    pay_now,
    pay_later,
    admin_paynow_status,
    admin_paylater_status,
  } = paymentConfig;

  // 🔥 ADMIN OVERRIDE RULES (TOP PRIORITY)
  if (admin_paylater_status === 1) {
    return { showPayNow: true, showPayLater: true };
  }

  if (admin_paynow_status === 1) {
    return { showPayNow: true, showPayLater: false };
  }

  // 🔽 USER DEFAULT RULES
  if (pay_later === 1) {
    return { showPayNow: true, showPayLater: true };
  }

  if (pay_now === 1) {
    return { showPayNow: true, showPayLater: false };
  }

  return { showPayNow: false, showPayLater: false };
}, [paymentConfig]);


const fetchPaymentKeys = async () => {
  try {
    setKeyLoading(true);

    const res = await fetch(`${BASE_URL}payment/keys`);
    const data = await res.json();

    if (Array.isArray(data) && data.length > 0) {
      setPaymentKeys({
        key_id: data[0].key_id,
        key_secret: data[0].key_secret
      });
    } else {
      console.error("Invalid keys response", data);
    }
  } catch (err) {
    console.error("Failed to fetch payment keys", err);
  } finally {
    setKeyLoading(false);
  }
};

  useEffect(() => {
  if (currentStep === 4) {
    fetchPaymentKeys();
  }
}, [currentStep]);

const resolvedCustomerId = existingCustomer?.id || wCustomerId;

const notes = {
    project: "warranty",
    service: "activation",
    imei1: form.deviceImei,
    imei2:form.deviceImei2,
    serial: form.serialNumber,
    product_id: selectedTemplate?.warranty_product_id,
    model_id: form.modelId,  
    company_id: retailer?.company_id,
    retailer_id: effectiveRetailerId,
    // agent_id: retailer?.agent_id,
    amount: retailerPending,
    w_customer_id: resolvedCustomerId,
    created_by: retailer?.id,
    document_url: form.billPhoto,
    link1: form.devicePhoto,
    zoho_id: authUser?.zoho_id || null,
}

  const handlePayNow = async () => {
  const money = (val) => Number(val).toFixed(2);
  
  if (useWallet) {
     setPaymentSaving(true); 

      try {
        const payload = {
          // DEVICE + PRODUCT
          name: product?.name,
          imei1: form.deviceImei,
          imei2: form.deviceImei2 || "",
          serial: form.serialNumber || "",

          brand_id: Number(form.deviceBrand),
          brand_name: form.brandName,
          category_id: Number(form.category),
          category_name: form.categoryName,

          product_id: product?.id,
          product_name: product?.name,

          model: form.deviceModel,
          model_id:form.modelId,

          // PRICING
          device_price: Number(form.mopPrice),
          product_price: Number(money(retailerPending)),
          product_mrp: Number(product?.mrp),

          // WARRANTY
          available_claim: product?.claims,
          expiry_date: form.expiryDate,

          // USERS
          company_id: retailer.company_id,
          retailer_id: effectiveRetailerId,
          w_customer_id: resolvedCustomerId,
          

          retailer_payout: retailer.retailer_payout,
          employee_payout: retailer.employee_payout,
          other_payout: retailer.other_payout,
          company_payout: retailer.company_payout,

          // META
          agent_id: retailer.agent_id || null,
          created_by: retailer.id,
          created_by_name: retailer?.business_name,
          promoter_id: effectivePromoterId,
          zoho_product_id: product?.zoho_product_id,
          amount: Number(money(retailerPending)),
          is_pay_later: 0,

          document_url: form.billPhoto,
          link1: form.devicePhoto,
          link2: form.customerPhoto,
          
          credit_amount: Number(money(retailerPending)),
          is_from_wallet: 1,
        };

        const res = await fetch(
          `${BASE_URL}warranty/create-warranty-with-credit`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
          }
        );

        const data = await res.json();

        if (!data.success) {
          toast.error(data.message || "Wallet payment failed");
          return;
        }

        toast.success(data.message || "Warranty activated using wallet");
        setPaymentSuccess(true);
        setConfirmed(true);

        // auto activate warranty
        setTimeout(() => {
          onNext();
        }, 500);

      } catch (err) {
        toast.error("Wallet payment failed");
      }finally {
        setPaymentSaving(false);   // 🔓 HIDE LOADER
      }
      return;
    }

  if (!paymentKeys?.key_id) {
    toast.error("Payment keys not loaded");
    return;
  }

  const roundedAmount = Math.round(Number(retailerPending) * 100);
  // console.log("rounded amount: ", roundedAmount)
  const options = {
    key: paymentKeys.key_id,
    amount: roundedAmount, // ₹1 for now (paise)
    currency: "INR",
    name: "Warranty Mitra",
    description: product?.name || "Warranty Payment",
    notes: notes,

    handler: async function (response) {
      try {
        setPaymentSaving(true); // 🔒 LOCK UI

        console.log("Razorpay Success:", response);

        // ✅ BUILD PAYLOAD (FOR FUTURE USE)
        const payload = {
          payment_id: response.razorpay_payment_id,

          // DEVICE + PRODUCT
          name: product?.name,
          imei1: form.deviceImei,
          imei2: form.deviceImei2 || "",
          serial: form.serialNumber || "",

          brand_id: Number(form.deviceBrand),
          category_id: Number(form.category),
          product_id: product?.id,
          product_name: product?.name,
          brand_name: form.brandName,
          category_name: form.categoryName,
          model: form.deviceModel,

          // WARRANTY
          available_claim: product?.claims,
          expiry_date: form.expiryDate,

          // USERS
          w_customer_id: existingCustomer?.id,
          retailer_id: effectiveRetailerId,
          agent_id: retailer.agent_id || null,

          // PRICING
          device_price: Number(form.mopPrice),
          product_price: retailerPending,
          product_mrp: Number(product?.mrp),

          retailer_payout: retailer.retailer_payout,
          employee_payout: retailer.employee_payout,
          other_payout: retailer.other_payout,
          company_payout: retailer.company_payout,

          // META
          company_id: retailer.company_id,
          created_by: retailer.id,
          created_by_name: retailer?.business_name,
          zoho_product_id: product?.zoho_product_id,
          amount: retailerPending,
        };

        console.log("Payment Payload (not sent):", payload);

        // ❌ API CALL INTENTIONALLY DISABLED
        /*
        const res = await fetch(`${BASE_URL}warranty/payment-flow`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        const data = await res.json();

        if (!res.ok || !data?.status) {
          toast.error("Payment done but warranty activation failed");
          return;
        }
        */

        // ✅ TEMP SUCCESS (PAYMENT ONLY)
        toast.success("Payment successful 🎉");
        setPaymentSuccess(true);

        setConfirmed(true);

        // auto activate warranty
        setTimeout(() => {
          onNext();
        }, 500);
      } catch (err) {
        console.error(err);
        toast.error("Payment succeeded but processing failed");
      } finally {
        setPaymentSaving(false); // 🔓 UNLOCK UI
      }
    },

    prefill: {
      name: form.name || "",
      email: form.email || "",
      contact: form.mobile || "",
    },

    theme: { color: "#2563eb" },
  };

  const rzp = new window.Razorpay(options);
  rzp.open();
};

const hideWalletForRetailerUser =
  Number(retailer?.role) === 6 &&
  (!retailer?.allow_wallet || Number(retailer?.allow_wallet) === 0);
// const handlePayNow = async () => {
//   if (!paymentKeys?.key_id) {
//     toast.error("Payment keys not loaded");
//     return;
//   }

//   const options = {
//     key: paymentKeys.key_id,
//     amount: 1 * 100, // Razorpay works in paise
//     currency: "INR",
//     name: "Warranty Mitra",
//     description: product?.name || "Warranty Payment",
//     notes:notes,

//     handler: async function (response) {
//       setPaymentSaving(true); // 🔒 FULL PAGE LOCK

//       const payload = {
//         payment_id: response.razorpay_payment_id,

//         // DEVICE + PRODUCT
//         name: product?.name,
//         imei1: form.deviceImei,
//         imei2: form.deviceImei2 || "",
//         serial: form.serialNumber || "",

//         brand_id: Number(form.deviceBrand),
//         category_id: Number(form.category),
//         product_id: product?.id,
//         product_name: product?.name,
//         brand_name: form.brandName,
//         category_name: form.categoryName,
//         model: form.deviceModel,

//         // WARRANTY
//         available_claim: product?.claims,
//         expiry_date: form.expiryDate,

//         // USERS
//         w_customer_id: existingCustomer?.id,
//         retailer_id: retailer.id,
//         agent_id: retailer.agent_id || null,

//         // PRICING
//         device_price: Number(form.mopPrice),
//         product_price: retailerPending,
//         product_mrp: Number(product?.mrp),

//         retailer_payout: retailer.retailer_payout,
//         employee_payout: retailer.employee_payout,
//         other_payout: retailer.other_payout,
//         company_payout: retailer.company_payout,

//         // META
//         company_id: retailer.company_id,
//         created_by: retailer.id,
//         zoho_product_id: product?.zoho_product_id,
//         amount: retailerPending,
//       };

//       try {
//         const res = await fetch(
//           `${BASE_URL}warranty/payment-flow`,
//           {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify(payload),
//           }
//         );

//         const data = await res.json();

//         if (!res.ok || !data?.status) {
//           toast.error("Payment done but warranty activation failed");
//           return;
//         }

//         toast.success("Payment successful & warranty activated 🎉");
//         // Navigate("/warranty/success");
//       } catch (err) {
//         console.error(err);
//         toast.error("Payment succeeded but server failed");
//       } finally {
//         setPaymentSaving(false); // 🔓 UNLOCK PAGE
//       }
//     },

//     prefill: {
//       name: form.name ,
//       email: form.email ,
//       contact: form.mobile,
//     },

//     theme: { color: "#2563eb" },
//   };

//   const rzp = new window.Razorpay(options);
//   rzp.open();
// };

  /* ================= STEP 1 : PRICING ================= */

  const glassCard = isRetailerMobile
  ? "bg-white/10 backdrop-blur-2xl border border-white/30 shadow-[0_20px_50px_rgba(31,38,135,0.25)]"
  : "bg-white border border-slate-200 shadow-lg";

  if (currentStep === 1) {
 const canViewTemplates =
  form.categoryName &&
  form.brandName &&
  form.deviceModel &&
  form.mopPrice;

  

  return (
    <div
      className={cn(
        "space-y-6 p-4 rounded-2xl transition-all duration-300",
        isRetailerMobile ? glassCard : ""
      )}
    >

      {/* ================= CATEGORY + BRAND + MODEL + PRICE ================= */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

        <div className="relative">
          <Input
            label="Search Model"
            value={form.deviceModel}
            onChange={handleModelChange}
            error={errors.deviceModel}
            placeholder="search model"
          />

          {modelQuery.length > 0 && modelQuery.length < 3 && (
            <p className="mt-1 text-xs text-slate-500">
              Type at least 3 characters to search
            </p>
          )}

          {/* DROPDOWN */}
          {modelLoading && (
            <div className={cn(
                "absolute z-10 mt-1 w-full rounded-xl p-2 text-sm",
                isRetailerMobile
                  ? "bg-white/20 backdrop-blur-xl border border-white/30 text-white"
                  : "bg-white border"
              )}>
              Loading...
            </div>
          )}

          {!modelLoading &&
            modelQuery.trim().length >= 3 &&
              modelResults.length === 0 && (
              <div className="absolute z-10 mt-1 w-full rounded-lg border border-slate-200 bg-white p-3 text-center text-sm text-slate-500">
                No model found. Search for a different model.
              </div>
          )}

          {!modelLoading && modelResults.length > 0 && (
            <ul className={cn("absolute z-10 mt-1 w-full border rounded-lg shadow max-h-[280px] overflow-y-auto" , isRetailerMobile ? "bg-blue-100 font-semibold" : " bg-white" )}>
              {modelResults.map((model) => (
                <li
                  key={model.id}
                  onClick={() => {
                      updateField(
                        "deviceModel",
                        `${model.name}${model.storage ? " - " + model.storage : ""}`
                      );
                      updateField("modelId", model.id);   
                      updateField("category", String(model.category.id));
                      updateField("categoryName", model.category.name);
                      updateField("deviceBrand", String(model.brand.id));
                      updateField("brandName", model.brand.name);
                      // updateField("mopPrice", model.price);
                      updateField("mopPrice", model.price);     // ✅ PREFILL VALUE
                      updateField("minMopPrice", model.price);  // ✅ STORE MIN LIMIT

                      setModelQuery("");      // ✅ IMPORTANT
                      onSearchModel("");      // clear results
                    }}

                  className="px-3 py-2 text-sm cursor-pointer hover:bg-blue-50 font-semibold"
                >
                  {model.name} - {model.storage}
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* CATEGORY */}
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium">Category</label>
            <Input
              value={form.categoryName}
              disabled
              placeholder="Auto-filled from model"
            />
          </div>


          {/* BRAND */}
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium">Brand</label>
            <Input
              value={form.brandName}
              disabled
              placeholder="Auto-filled from model"
            />
          </div>

        {/* <Input
          label="MOP Price (₹)"
          type="number"
          value={form.mopPrice}
          disabled
          placeholder="Auto-filled from model"
        /> */}

        <Input
          label="MOP Price (₹)"
          type="number"
          min={form.minMopPrice}   // 👈 browser-level restriction
          value={form.mopPrice}
          onChange={(e) => {
            const value = Number(e.target.value);

            // // ❌ prevent less than API price
            // if (value < form.minMopPrice) {
            //   toast.error(`Price cannot be less than ₹${form.minMopPrice}`);
            //   return;
            // }

            updateField("mopPrice", value);
          }}
        />

        <p className="text-xs text-gray-500">
          Minimum allowed price: ₹{form.minMopPrice}
        </p>
      </div>

      {/* ================= VIEW TEMPLATES BUTTON ================= */}
      <button
        onClick={onViewTemplates}
        disabled={!canViewTemplates || loading}
        className={`px-6 py-2 rounded-lg text-sm font-medium
          ${
            canViewTemplates
              ? "bg-blue-600 text-white hover:bg-blue-700"
              : "bg-slate-200 text-slate-500 cursor-not-allowed"
          }`}
      >
        {loading ? "Loading..." : "Get Products"}
      </button>

      {/* NO TEMPLATE MESSAGE */}
      {!loading && noTemplateMessage && (
        <div className="mt-6 flex justify-center">
          <div className="w-full max-w-md rounded-2xl border border-amber-200 bg-amber-50 p-6 text-center">
            <div className="text-amber-700 text-sm font-semibold">
              {noTemplateMessage}
            </div>
            <p className="mt-1 text-xs text-amber-600">
              Try changing device price or selecting a different model.
            </p>
          </div>
        </div>
      )}

      {/* ================= DESKTOP GRID ================= */}
{priceTemplates.length > 0 && (
  <WarrantyPlanGrid
    priceTemplates={priceTemplates}
    selectedTemplate={selectedTemplate}
    setSelectedTemplate={setSelectedTemplate}
    updateField={updateField}
    form={form}
    expandAll={expandAll}
    setExpandAll={setExpandAll}
    expandedCoverage={expandedCoverage}
    setExpandedCoverage={setExpandedCoverage}
    isRetailerMobile={isRetailerMobile}
  />
)}

    </div>
  );
}

  /* ================= STEP 2 : DEVICE ================= */

  if (currentStep === 2) {
  return (
    <div className="space-y-6">

      {/* PHONE VERIFICATION (INLINE) */}
      <PhoneVerifyModal
        onResult={(success, mobile, customerData) => {

          if (!success) {
            // ❌ NOT VERIFIED
            setIsPhoneVerified(false);

            updateField("mobile", mobile || "");
            updateField("name", "");
            updateField("email", "");
            updateField("pincode", "");
            updateField("state", "");
            updateField("city", "");
            updateField("location", "");
            return;
          }

          // ✅ VERIFIED
          setIsPhoneVerified(true);
          updateField("mobile", mobile);

          if (customerData) {
            updateField("name", customerData.name || "");
            updateField("email", customerData.email || "");
            updateField("addressLine1", customerData.address1 || "");
            updateField("addressLine2", customerData.address2 || "");
            updateField("pincode", customerData.pincode || "");
            updateField("state", customerData.state || "");
            updateField("city", customerData.city || "");
            updateField("location", customerData.location || "");
          }
        }}
      />

      {!isPhoneVerified && (
        <p
          className={cn(
            "text-xs rounded-xl p-2 border",
            isRetailerMobile
              ? "glass-small-card bg-white/10 border-white/30 text-amber-500 font-bold !text-md"
              : "text-amber-600 bg-amber-50 border-amber-200"
          )}
        >
          Please verify mobile number to add customer details
        </p>
      )}

      {/* -------- CONTACT DETAILS -------- */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <Input
          label="Customer Name"
          value={form.name}
          disabled={!isPhoneVerified}
          onChange={(e) => updateField("name", e.target.value)}
          error={errors.name}
          placeholder={"Enter Full Name"}
        />



        <Input
          label="Mobile"
          value={form.mobile}
          disabled
          placeholder={"Auto Filled from verified"}
        />

        <Input
          label="Email"
          value={form.email}
          disabled={!isPhoneVerified}
          onChange={(e) => updateField("email", e.target.value)}
          error={errors.email}
          placeholder={"Enter Valid Mail ID"}
        />

      </div>

      {/* -------- LOCATION DETAILS -------- */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">

        {/* ADDRESS LINE 1 (FULL WIDTH) */}
        <div className="col-span-2 sm:col-span-1">
          <Input
            label="Address Line 1"
            value={form.addressLine1}
            disabled={!isPhoneVerified}
            onChange={(e) => updateField("addressLine1", e.target.value)}
            error={errors.addressLine1}
            placeholder="House no. / Building Name "
          />
        </div>

        {/* ADDRESS LINE 2 (FULL WIDTH) */}
        <div className="col-span-2 sm:col-span-1">
          <Input
            label="Address Line 2"
            placeholder="Area / Street / Landmark"
            value={form.addressLine2}
            disabled={!isPhoneVerified}
            onChange={(e) => updateField("addressLine2", e.target.value)}
            error={errors.addressLine2}
          />
        </div>


        <div className="col-span-2 sm:col-span-1">
          <Input
            label="Location"
            placeholder="Locality / Area"
            value={form.location}
            disabled={!isPhoneVerified}
            onChange={(e) => updateField("location", e.target.value)}
            error={errors.location}
          />
        </div>

        {/* PINCODE */}
        <div className="col-span-2 sm:col-span-1">
            
          <Input
            label="Pincode"
            value={form.pincode}
            disabled={!isPhoneVerified}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              updateField("pincode", value);
              if (value.length === 6) onPincodeChange(value);
            }}
            error={errors.pincode}
            placeholder="Enter valid 6 digit pincode"
          />
  
        </div>

      {/* STATE */}
      <div className="col-span-2 sm:col-span-1">
        <Input label="State" value={form.state} disabled placeholder="Auto Filled from pincode" />
      </div>
        

        {/* CITY */}
        <div className="col-span-2 sm:col-span-1">
          <Input label="City" value={form.city} disabled placeholder="Auto Filled from pincode"/>
        </div>
        
      </div>

    </div>
  );
}

  /* ================= STEP 3 : CONTACT + LOCATION ================= */
  if (currentStep === 3) {
  return (
  <>
    <div className="space-y-6">

      {/* DEVICE INFO */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <Input label="Device Brand" value={form.brandName} disabled />
        <Input label="Device Model" value={form.deviceModel} disabled />
        <Input label="MOP (₹)" value={form.mopPrice} disabled />

        <Input
          label="IMEI 1"
          value={form.deviceImei}
          onChange={(e) => {
            const onlyDigits = e.target.value.replace(/\D/g, "");

            // 🔒 limit to 16 digits
            if (onlyDigits.length > 15) return;

            updateField("deviceImei", onlyDigits);
          }}
          error={errors.deviceImei}
          // rightIcon={
          //   <button
          //     type="button"
          //     onClick={() => {
          //       setScanTarget("deviceImei");
          //       setShowScanner(true);
          //     }}
          //     className="text-blue-600 hover:text-blue-700"
          //     title="Scan IMEI 1"
          //   >
          //     <ScanLine size={16} />
          //   </button>
          // }
        />

        {/* OPTIONAL IMAGE UPLOAD */}
        {/* <div className="text-xs text-slate-500">
          Or upload barcode image:
          <input
            type="file"
            accept="image/*"
            className="block mt-1"
            onChange={async (e) => {
              const file = e.target.files[0];
              if (!file) return;

              try {
                const imei = await scanImeiFromImage(file);
                updateField("deviceImei", imei);
                toast.success("IMEI detected from image");
              } catch {
                toast.error(
                  "Could not read IMEI from image. Please use camera scan or enter manually."
                );
              }
            }}
          />
        </div> */}

        <Input
          label="IMEI 2"
          value={form.deviceImei2}
          onChange={(e) =>{
            const onlyDigits = e.target.value.replace(/\D/g, "");

            // 🔒 limit to 16 digits
            if (onlyDigits.length > 15) return;

            updateField("deviceImei2", onlyDigits);
          } 
          }
          // rightIcon={
          //   <button
          //     type="button"
          //     onClick={() => {
          //       setScanTarget("deviceImei2");
          //       setShowScanner(true);
          //     }}
          //     className="text-blue-600 hover:text-blue-700"
          //     title="Scan IMEI 2"
          //   >
          //     <ScanLine size={16} />
          //   </button>
          // }
        />

        {/* <input
          type="file"
          accept="image/*"
          className="text-xs"
          onChange={async (e) => {
            const file = e.target.files[0];
            if (!file) return;

            try {
                const imei = await decodeBarcodeFromImage(file);
                updateField("deviceImei", imei);
                toast.success("IMEI scanned successfully");
              } catch (err) {
                toast.error(
                  "Unable to detect IMEI. Please upload a clearer image or scan using camera."
                );
              }
          }}
        /> */}

        <Input
          label="Serial Number"
          value={form.serialNumber}
          onChange={(e) => {
            const value = e.target.value
              .replace(/[^a-zA-Z0-9]/g, "") // allow only alphanumeric
              .toUpperCase();              // optional: normalize

            if (value.length > 16) return;

            updateField("serialNumber", value);
          }}
          error={errors.serialNumber}
        />

      </div>

      {/* IMAGE UPLOADS */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">

        <ImageUpload
          label="Bill Photo"
          value={form.billPhoto}
          required
          error={errors.billPhoto}
          onChange={(file) =>
            handleImageUpload("billPhoto", file, "bill_photo")
          }
        />

        <ImageUpload
          label="Device Photo"
          value={form.devicePhoto}
          // required
          error={errors.devicePhoto}
          onChange={(file) =>
            handleImageUpload("devicePhoto", file, "device_photo")
          }
        />

        {/* <ImageUpload
          label="Customer Photo"
          value={form.customerPhoto}
          required
          error={errors.customerPhoto}
          onChange={(file) =>
            handleImageUpload("customerPhoto", file, "customer_photo")
          }
        /> */}

      </div>
    </div>
    
      {showScanner && (
        <ImeiScanner
          onScan={(imei) => {
            updateField(scanTarget, imei);

            if (scanTarget === "deviceImei" && !form.deviceImei2) {
              updateField("deviceImei2", imei);
            }

            // ✅ ONLY CLOSE MODAL
            setShowScanner(false);
          }}
          onClose={() => setShowScanner(false)}
        />
      )}
</>
  );
}

  /* ================= STEP 4 : PAYMENT ================= */
  if (currentStep === 4) {
  const Planname = product?.product_type;
  const isOfferPlan = product?.is_offer === 1;
  const subscribedPackages = product?.subscribed_packages || [];

  const balanceLeft =
    subscribedPackages.length > 0
      ? subscribedPackages[0]?.balance
      : 0;

  const endDate = subscribedPackages[0]?.end_date;

  let remainingDays = null;

  if (endDate) {
    const today = new Date();
    const expiry = new Date(endDate);

    const diffTime = expiry - today;
    remainingDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  }

  return (
    <div className="w-full">
      {/* TOP BAR */}
      {/* <div className="rounded-2xl border border-slate-200 bg-white shadow-lg"> */}
        <div className="p-2 sm:p-3">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
            <div>
              <h2 className="text-lg sm:text-xl font-semibold text-slate-900">
                Confirm Warranty Registry
              </h2>
              <p className="mt-1 text-xs sm:text-sm text-slate-500">
                Review details and confirm to activate warranty.
              </p>
            </div>

            <div className="flex items-center gap-2">
              {/* <Pill tone="amber">Pay Later</Pill> */}
              <Pill tone="indigo">Step 4 of 4</Pill>
            </div>
          </div>

          {/* BANNER */}
          <div
            className={cn(
              "mt-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between rounded-2xl p-4 transition-all duration-300",
              isRetailerMobile
                ? "glass-small-card bg-white/10 backdrop-blur-2xl border border-white/20 !text-left"
                : "border border-indigo-200 bg-gradient-to-r from-indigo-50 to-white shadow-lg"
            )}
          >
            <div className="flex items-center gap-3">
              <div
                className={cn(
                  "h-10 w-10 rounded-2xl grid place-items-center shadow-lg",
                  isRetailerMobile
                    ? "bg-white/20 text-white backdrop-blur-md border border-white/30"
                    : "bg-indigo-600 text-white"
                )}
              >
                🛡️
              </div>

              <div>
                <p
                  className={cn(
                    "text-sm font-semibold",
                    isRetailerMobile ? "text-black" : "text-indigo-900"
                  )}
                >
                  Warranty Order Confirmation
                </p>

                <p
                  className={cn(
                    "text-xs",
                    isRetailerMobile ? "text-black/70" : "text-indigo-700"
                  )}
                >
                  Verify customer, device & plan before submission.
                </p>
              </div>
            </div>

            <div className="flex flex-wrap gap-2">
              <Pill tone={isRetailerMobile ? "glass" : "emerald"}>
                Instant Activation
              </Pill>

              <Pill tone={isRetailerMobile ? "glass" : "slate"}>
                IMEI Linked
              </Pill>
            </div>
          </div>
        </div>

        {/* CONTENT */}
        <div
          className={cn(
            "p-2 sm:p-3 border-t",
            isRetailerMobile
              ? "border-white/20 bg-white/5 backdrop-blur-md"
              : "border-slate-200 bg-slate-50/40"
          )}
        >
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
            {/* LEFT */}
            <div className="lg:col-span-12 space-y-6">
              {/* CUSTOMER */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                <div className={cn(
                    "rounded-2xl shadow-lg",
                    isRetailerMobile
                      ? "glass-small-card bg-white/10 border border-white/20 backdrop-blur-xl"
                      : "border border-slate-200 bg-white"
                  )}>
                <div className="p-2 sm:p-5">
                  <div className="flex items-center justify-between">
                    <h4
                      className={cn(
                        "text-sm font-semibold",
                        isRetailerMobile ? "text-black" : "text-slate-900"
                      )}
                    >
                      Customer Information
                    </h4>
                    <Pill tone="slate">Customer</Pill>
                  </div>

                  <div className="mt-4 space-y-2">
                    <SummaryRow label="Customer Name" value={form?.name} />
                    <SummaryRow label="Mobile Number" value={form?.mobile} />
                    <SummaryRow label="Location" value={form?.location} />
                  </div>
                </div>
              </div>

              {/* DEVICE */}
              <div className={cn(
                "rounded-2xl shadow-lg",
                isRetailerMobile
                  ? "glass-small-card bg-white/10 border border-white/20 backdrop-blur-xl"
                  : "border border-slate-200 bg-white"
              )}>
                <div className="p-2 sm:p-5">
                  <div className="flex items-center justify-between">
                    <h4 className="text-sm font-semibold text-slate-900">
                      Device Information
                    </h4>
                    <Pill tone="slate">Device</Pill>
                  </div>

                  <div className="mt-4 space-y-2">
                    <SummaryRow label="Brand" value={form?.brandName} />
                    <SummaryRow label="Model" value={form?.deviceModel} />
                    <SummaryRow
                      label="Device Price (MOP)"
                      value={
                        form?.mopPrice !== undefined ? `₹${form?.mopPrice}` : "-"
                      }
                      bold
                    />
                    <SummaryRow label="IMEI 1" value={form?.deviceImei} />
                    {form?.deviceImei2 ? (
                      <SummaryRow label="IMEI 2" value={form?.deviceImei2} />
                    ) : null}
                  </div>
                </div>
              </div>
              </div>

              {/* PLAN */}
              <div className={cn(
                "rounded-2xl shadow-lg overflow-hidden",
                isRetailerMobile
                  ? "glass-small-card bg-white/10 border border-white/20 backdrop-blur-xl !text-left"
                  : "border border-indigo-200 bg-white"
              )}>
                <div className={cn(
                    "p-4 sm:p-5",
                    isRetailerMobile
                      ? "bg-white/40 backdrop-blur-xl border border-white/10"
                      : "bg-gradient-to-r from-indigo-50 to-white"
                  )}>
                  <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                    <div>
                      <Pill tone="indigo">Warranty Plan</Pill>
                      <h4 className="mt-2 text-sm font-semibold text-slate-900">
                        Plan Details
                      </h4>
                      <p className="text-xs text-slate-500 my-2">
                        Make sure plan & expiry are correct.
                      </p>
                      <Pill tone="blue">
                        Plan Validity: {product?.validity ?? "-"} Days
                      </Pill>

                    </div>

                    <div className="flex gap-2 flex-wrap">
                      <Pill tone="emerald">
                        Claims: {product?.claims ?? "-"}
                      </Pill>
                      <Pill tone="slate">Expiry: {form?.expiryDate || "-"}</Pill>
                    </div>
                  </div>

                  <div className="mt-4 space-y-2">
                    <SummaryRow label="Plan Name" value={product?.name} />
                    {/* <SummaryRow
                      label="Warranty Price"
                      value={
                        selectedTemplate?.product_price !== undefined
                          ? `₹${selectedTemplate?.product_price}`
                          : "-"
                      }
                      bold
                    /> */}
                  </div>
                </div>

                {/* FEATURES */}
                <div className="grid grid-cols-1 sm:grid-cols-3">
                  <div className="p-4 sm:p-5 border-t border-slate-200">
                    <p className="text-xs font-semibold text-slate-700 mb-3">
                      Plan Features
                    </p>

                    {features.length ? (
                      <>
                        <div className="flex flex-wrap gap-2">
                          {(expanded.features ? features : features.slice(0, 4)).map((f, i) => (
                            <span
                              key={i}
                              className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-3 py-1 text-xs font-medium text-slate-700 ring-1 ring-slate-200"
                            >
                              {f}
                            </span>
                          ))}
                        </div>

                        {features.length > 4 && (
                          <button
                            onClick={() =>
                              setExpanded((prev) => ({
                                ...prev,
                                features: !prev.features,
                              }))
                            }
                            className="mt-3 text-xs font-semibold text-blue-600 hover:underline"
                          >
                            {expanded.features ? "View Less" : "View More"}
                          </button>
                        )}
                      </>
                    ) : (
                      <p className="text-xs text-slate-400 italic">
                        No features available
                      </p>
                    )}
                  </div>

                <div className="p-4 sm:p-5 border-t border-slate-200">
                  <p className="text-xs font-semibold text-slate-700 mb-3">
                    Coverage
                  </p>

                  {coverage?.length ? (
                    <>
                      <div className="flex flex-wrap gap-2">
                        {(expanded.coverage ? coverage : coverage.slice(0, 4)).map((c, i) => (
                          <span
                            key={i}
                            className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-3 py-1 text-xs font-medium text-emerald-700 ring-1 ring-emerald-200"
                          >
                            <span className="text-emerald-600">✔</span>
                            {c}
                          </span>
                        ))}
                      </div>

                      {coverage.length > 4 && (
                        <button
                          onClick={() =>
                            setExpanded((prev) => ({
                              ...prev,
                              coverage: !prev.coverage,
                            }))
                          }
                          className="mt-3 text-xs font-semibold text-blue-600 hover:underline"
                        >
                          {expanded.coverage ? "View Less" : "View More"}
                        </button>
                      )}
                    </>
                  ) : (
                    <p className="text-xs text-slate-400 italic">
                      No coverage details available
                    </p>
                  )}
                </div>

                <div className="p-4 sm:p-5 border-t border-slate-200">
                  <p className="text-xs font-semibold text-slate-700 mb-3">
                    Exclusions
                  </p>

                  {exclusions?.length ? (
                    <>
                      <div className="flex flex-wrap gap-2">
                        {(expanded.exclusions ? exclusions : exclusions.slice(0, 4)).map((e, i) => (
                          <span
                            key={i}
                            className="inline-flex items-center gap-1 rounded-full bg-blue-50 px-3 py-1 text-xs font-medium text-blue-700 ring-1 ring-blue-200"
                          >
                            <span className="text-blue-600">✔</span>
                            {e}
                          </span>
                        ))}
                      </div>

                      {exclusions.length > 4 && (
                        <button
                          onClick={() =>
                            setExpanded((prev) => ({
                              ...prev,
                              exclusions: !prev.exclusions,
                            }))
                          }
                          className="mt-3 text-xs font-semibold text-blue-600 hover:underline"
                        >
                          {expanded.exclusions ? "View Less" : "View More"}
                        </button>
                      )}
                    </>
                  ) : (
                    <p className="text-xs text-slate-400 italic">
                      No exclusions specified
                    </p>
                  )}
                </div>
                </div>

              </div>

              {/* ACTIVATION SUMMARY */}
              
            </div>            
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 mt-3">
            <div className="lg:col-span-4">
                <div className="lg:sticky lg:top-4 ">
                <div className={cn(
                  "rounded-2xl shadow-lg",
                  isRetailerMobile
                    ? "glass-small-card bg-white/10 border border-white/20 backdrop-blur-xl"
                    : "border border-slate-200 bg-white"
                )}>
                  <div className="p-4 sm:p-5">
                    <div className="flex items-center justify-between mb-3">
                      <h4 className="text-sm font-semibold text-slate-900">
                        {product?.is_offer === 1
                          ? "Subscription Summary"
                          : "Settlement Summary"}
                      </h4>
                      { !isOfferPlan && (
                        <div
                          onClick={() => setShowSettlement((prev) => !prev)}
                          className="cursor-pointer"
                        >
                          <Pill tone="amber">
                            Retailer Due {showSettlement ? "▲" : "▼"}
                          </Pill>
                        </div>
                      )}
                    </div>

                   {isOfferPlan ? (
                      <div className="mt-4 space-y-3 animate-fadeIn">

                        <SummaryRow
                          label="Plan Type"
                          value={Planname}
                          bold
                        />

                        <SummaryRow
                          label="Subscription Enrollments Left"
                          value={balanceLeft}
                        />

                        {/* <SummaryRow
                          label="Validity"
                          value={
                            remainingDays > 0
                              ? `Expires in ${remainingDays} days`
                              : "Expired"
                          }
                        /> */}

                      </div>
                    ) : (
                      <>
                        <SummaryRow
                          label="Product Price"
                          value={`₹${productPrice}`}
                          bold
                        />

                        {showSettlement && (
                          <div className="mt-4 space-y-3 animate-fadeIn">
                            <SummaryRow
                              label="Retailer Payout"
                              value={`₹${retailerPayout}`}
                            />

                            <div className="my-3 h-px bg-slate-200" />

                            <SummaryRow
                              label="Total Payout"
                              value={`₹${TotalPayout}`}
                            />

                            <div className="my-3 h-px bg-slate-200" />

                            <div className="mt-3 rounded-2xl p-4 border border-amber-200 bg-amber-50">
                              <p className="text-[11px] text-amber-800/80">
                                Amount to be collected from retailer
                              </p>
                              <p className="mt-1 text-xl font-bold text-amber-900">
                                ₹{retailerPending}
                              </p>
                            </div>
                          </div>
                        )}
                      </>
                    )}

                    {loadingPaymentConfig && (
                      <div className="mt-4 rounded-xl border border-slate-200 bg-slate-50 p-4 text-xs text-slate-500">
                        Loading payment options…
                      </div>
                    )}

                    {/* PAYMENT ACTION */}
                    {!isOfferPlan &&
                      !loadingPaymentConfig &&
                      !paymentSuccess &&
                      (paymentButtons.showPayNow || paymentButtons.showPayLater) && (

                      <div
                        className={cn(
                          "mt-4 rounded-2xl p-4",
                          isRetailerMobile
                            ? "glass-small-card bg-white/10 backdrop-blur-xl border border-white/20"
                            : "border border-slate-200 bg-slate-50"
                        )}
                      >
                        <p
                          className={cn(
                            "text-xs font-semibold mb-3",
                            isRetailerMobile ? "text-black/80" : "text-slate-600"
                          )}
                        >
                          Choose payment method
                        </p>

                        {/* BUTTON ROW */}
                        <div className="space-y-4">

                            {/* WALLET CARD */}
                            {!payLaterSelected && !hideWalletForRetailerUser && (
                            <div
                              className={cn(
                                "relative rounded-2xl border p-3 transition-all duration-300",
                                walletDisabled
                                  ? "bg-slate-100 border-slate-200 opacity-60 cursor-not-allowed pointer-events-none"
                                  : "bg-gradient-to-r from-emerald-50 to-emerald-100 border-emerald-200 hover:shadow-md"
                              )}
                            >
                              {/* TOP ROW */}
                              <div className="flex items-start justify-between">

                                <div className="flex items-start gap-2">

                                  {/* Checkbox */}
                                  <input
                                    type="checkbox"
                                    disabled={walletDisabled || walletLoading}
                                    checked={useWallet}
                                    onChange={(e) => setUseWallet(e.target.checked)}
                                    className="mt-1 h-4 w-4 rounded border-slate-300 text-emerald-600"
                                  />

                                  {/* Icon */}
                                  <div
                                    className={cn(
                                      "flex items-center justify-center w-10 h-10 rounded-xl",
                                      walletDisabled
                                        ? "bg-slate-200 text-slate-400"
                                        : "bg-white text-emerald-600 shadow-sm"
                                    )}
                                  >
                                    <Wallet size={18} />
                                  </div>

                                  {/* Text */}
                                  <div>
                                    <p
                                      className={cn(
                                        "font-semibold text-sm",
                                        walletDisabled ? "text-slate-400" : "text-slate-800"
                                      )}
                                    >
                                      Wallet Balance
                                    </p>

                                    {!walletDisabled && (
                                      <p className="text-xs text-slate-500">
                                        Use wallet to pay instantly
                                      </p>
                                    )}
                                  </div>
                                </div>

                                {/* BALANCE */}
                                {!walletLoading && (
                                  <div
                                    className={cn(
                                      "px-3 py-1 rounded-lg font-bold",
                                      walletDisabled
                                        ? "bg-slate-200 text-slate-400 text-sm"
                                        : "bg-white text-emerald-700 shadow-sm text-sm"
                                    )}
                                  >
                                    ₹{walletBalance}
                                  </div>
                                )}
                              </div>

                              {/* WARNING */}
                              {!walletLoading && walletDisabled && (
                                <div className="flex items-center gap-2 mt-3 text-sm text-red-600 text-bold">
                                  <AlertTriangle size={14} />
                                  Insufficient wallet balance
                                </div>
                              )}
                            </div>
                          )}

                            {/* PAYMENT BUTTONS */}
                            <div className="flex gap-3">

                              {/* PAY NOW */}
                              {paymentButtons.showPayNow && !payLaterSelected && (
                                <button
                                  type="button"
                                  onClick={() =>
                                    setConfirmModal({
                                      open: true,
                                      type: useWallet ? "wallet" : "paynow",
                                    })
                                  }
                                  disabled={paymentSaving}
                                  className={cn(
                                    "flex-1 rounded-xl px-4 py-2.5 text-sm font-semibold shadow-sm transition flex items-center justify-center gap-2",
                                    paymentSaving
                                      ? "bg-slate-400 cursor-not-allowed text-white"
                                      : isRetailerMobile
                                      ? "bg-emerald-500/80 backdrop-blur text-white border border-white/30"
                                      : "bg-emerald-600 text-white hover:bg-emerald-700"
                                  )}
                                >
                                  {paymentSaving ? (
                                    <>
                                      <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                                      Processing..
                                    </>
                                  ) : (
                                    "Pay Now"
                                  )}
                                </button>
                              )}

                              {/* PAY LATER */}
                              {paymentButtons.showPayLater && (
                                <button
                                  type="button"
                                  onClick={() =>
                                    setConfirmModal({
                                      open: true,
                                      type: "paylater",
                                    })
                                  }
                                  className={cn(
                                    "flex-1 rounded-xl px-4 py-2.5 text-sm font-semibold transition border",
                                    payLaterSelected
                                      ? isRetailerMobile
                                        ? "glass-small-card bg-white/25 text-black border-white/40"
                                        : "border-amber-400 bg-amber-100 text-amber-900"
                                      : isRetailerMobile
                                        ? " bg-white/10 text-black border-white/30 hover:bg-white/20"
                                        : "border-amber-300 bg-amber-50 text-amber-800 hover:bg-amber-100"
                                  )}
                                >
                                  {payLaterSelected ? "✓ Pay Later Selected" : "Pay Later"}
                                </button>
                              )}
                            </div>

                          </div>

                        

                        {/* ADMIN NOTE */}
                        {(paymentConfig.admin_paylater_status === 1 ||
                          paymentConfig.admin_paynow_status === 1) && (
                          <p
                            className={cn(
                              "mt-3 text-[11px] font-medium text-center",
                              isRetailerMobile ? "text-black/60" : "text-slate-500"
                            )}
                          >
                            Payment options enforced by company policy.
                          </p>
                        )}
                      </div>
                    )}

                    {paymentSuccess && (
                      <div className={cn(
                          "mt-4 rounded-2xl p-4 text-center",
                          isRetailerMobile
                            ? "bg-white/10 border border-white/20 backdrop-blur-md text-white"
                            : "border border-emerald-300 bg-emerald-50"
                        )}>
                        <div className="flex flex-col items-center gap-2">
                          <div className="h-10 w-10 rounded-full bg-emerald-600 text-white flex items-center justify-center text-lg">
                            ✓
                          </div>

                          <p className="text-sm font-semibold text-emerald-900">
                            Payment Successful
                          </p>

                          <p className="text-xs text-emerald-700">
                            Proceed to activate warranty
                          </p>

                          {/* <button
                            type="button"
                            onClick={() => {
                              // 🔥 FINAL WARRANTY ACTIVATION API
                              // call activateWarranty()
                              toast.success("Warranty activated successfully");
                            }}
                            className="mt-3 w-full rounded-xl bg-emerald-600 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-700 transition"
                          >
                            Proceed to Register Warranty
                          </button> */}
                        </div>
                      </div>
                    )}

                    {payLaterSelected && (
                      <div className="mt-3 rounded-lg bg-amber-50 border border-amber-200 px-3 py-2 text-xs text-amber-800">
                        Payment mode: <b>Pay Later</b>. Warranty will be activated now and payment
                        collected later.
                      </div>
                    )}

                  </div>
                </div>

              </div>
              </div>

                <div className="lg:col-span-8">
                <div className="rounded-2xl border border-emerald-200 bg-emerald-50 shadow-lg">
                <div className="p-4 sm:p-5">
                  <div className="flex items-center justify-between">
                    <h4 className="text-sm font-semibold text-emerald-900">
                      Activation Summary
                    </h4>
                    <Pill tone="emerald">Ready</Pill>
                  </div>

                  <ul className="mt-4 space-y-2 text-xs sm:text-sm text-emerald-900">
                    <li className="flex gap-2">
                      <span>✔</span> Warranty activates instantly after confirm
                    </li>
                    <li className="flex gap-2">
                      <span>✔</span> Linked to IMEI for validation
                    </li>
                    <li className="flex gap-2">
                      <span>✔</span> Customer receives SMS confirmation
                    </li>
                    <li className="flex gap-2">
                      <span>✔</span> Valid until{" "}
                      <b className="font-semibold">{form?.expiryDate || "-"}</b>
                    </li>
                  </ul>
                </div>
              </div>

              <label
                className={`mt-4 flex items-start gap-3 rounded-xl border p-3 cursor-pointer
                  ${
                    payLaterSelected || paymentSuccess || isOfferPlan
                      ? "border-slate-200 bg-slate-50"
                      : "border-slate-200 bg-slate-100 opacity-60 cursor-not-allowed"
                  }
                `}
              >
                <input
                  type="checkbox"
                  disabled={
                    isOfferPlan
                      ? false
                      : (!payLaterSelected && !paymentSuccess)
                  }
                  className="mt-1 h-4 w-4 rounded border-slate-300 text-indigo-600 focus:ring-indigo-600"
                  checked={confirmed}
                  onChange={(e) => setConfirmed(e.target.checked)}
                />

                <span className="text-xs text-slate-800 leading-5">
                  I confirm that all device details, IMEI numbers and warranty plan information
                  are correct.
                </span>
              </label>
              </div>
              
            </div>

          {/* MOBILE BOTTOM BAR (optional feel) */}
          {!paymentSuccess && (
            <div
            className={cn(
              "mt-6 lg:hidden rounded-2xl p-4 shadow-lg",
              isRetailerMobile
                ? "glass-small-card bg-white/10 backdrop-blur-xl border border-white/20"
                : "border border-slate-200 bg-white"
            )}
          >
            <div className="flex items-center justify-between">
              <p
                className={cn(
                  "text-xs",
                  isRetailerMobile ? "text-black/70" : "text-slate-500"
                )}
              >
                Retailer Pending
              </p>

              <p
                className={cn(
                  "text-sm font-semibold",
                  isRetailerMobile ? "text-black" : "text-slate-900"
                )}
              >
                ₹{retailerPending}
              </p>
            </div>
          </div>
          )}
        </div>
      {/* </div> */}

      <ConfirmSheet
        open={confirmModal.open}
        type={confirmModal.type}
        title="Confirm Action"
        message={
          confirmModal.type === "wallet"
            ? "Pay using wallet balance?"
            : confirmModal.type === "paynow"
            ? "Proceed to payment?"
            : "Activate warranty and pay later?"
        }
        confirmText="Yes"
        cancelText="Cancel"
        onCancel={() => setConfirmModal({ open: false, type: null })}
        onConfirm={() => {
          if (confirmModal.type === "wallet" || confirmModal.type === "paynow") {
            handlePayNow();
          }

          if (confirmModal.type === "paylater") {
            setPayLaterSelected(true);
            setIsPayLater(1);
            setConfirmed(false);
            toast.success("Pay Later selected");
          }

          setConfirmModal({ open: false, type: null });
        }}
      />

      {/* LOADER OVERLAY */}
      {/* {paymentSaving && (
        <div
          className={cn(
            "fixed inset-0 z-50 flex flex-col items-center justify-center backdrop-blur",
            isRetailerMobile
              ? "bg-black/40"
              : "bg-white/70"
          )}
        >
          <RegularLoader />
          <p
            className={cn(
              "mt-3 text-sm",
              isRetailerMobile ? "text-white" : "text-slate-600"
            )}
          >
            Processing payment…
          </p>
        </div>
      )} */}
    </div>
  );
}

  return null;
};

function SummaryRow({ label, value, bold = false }) {
  return (
    <div className="flex items-start justify-between gap-4">
      <p className="text-xs sm:text-sm text-slate-500">{label}</p>
      <p
        className={[
          "text-xs sm:text-sm text-slate-900 text-right break-words",
          bold ? "font-semibold" : "font-medium",
        ].join(" ")}
      >
        {value || "-"}
      </p>
    </div>
  );
}

function Pill({ children, tone = "slate" }) {
  const tones = {
    slate: "bg-slate-100 text-slate-700 ring-slate-200",
    indigo: "bg-indigo-100 text-indigo-700 ring-indigo-200",
    emerald: "bg-emerald-100 text-emerald-700 ring-emerald-200",
    amber: "bg-amber-100 text-amber-800 ring-amber-200",
  };
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-semibold ring-1 ${tones[tone]}`}
    >
      {children}
    </span>
  );
}

function ConfirmSheet({
  open,
  title,
  message,
  type,
  confirmText = "Yes",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  const isMobile = window.innerWidth < 640;

  const iconMap = {
    wallet: {
      icon: "💰",
      desc: "Amount will be deducted from your wallet balance.",
      color: "text-emerald-400",
    },
    paynow: {
      icon: "💳",
      desc: "You will be redirected to secure payment.",
      color: "text-blue-400",
    },
    paylater: {
      icon: "⏳",
      desc: "Warranty will provisioned and payment can be collected later.",
      color: "text-amber-400",
    },
  };

  const info = iconMap[type] || {};

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-sm">

      {isMobile ? (
        <div className="absolute bottom-0 w-full max-w-md rounded-t-3xl glass-small-card bg-white/10 backdrop-blur-2xl border border-white/20 p-6 min-h-[260px] animate-slideUp">

          {/* HANDLE */}
          <div className="w-12 h-1.5 bg-white/40 rounded-full mx-auto mb-4" />

          {/* ICON */}
          <div className="flex justify-center mb-3">
            <div className="text-3xl">{info.icon}</div>
          </div>

          <h3 className="text-lg font-semibold text-center text-slate-200">
            {title}
          </h3>

          <p className="mt-2 text-sm text-center text-slate-300">
            {message}
          </p>

          {info.desc && (
            <p className={`mt-2 text-xs text-center ${info.color}`}>
              {info.desc}
            </p>
          )}

          <div className="mt-6 flex gap-3">
            <button
              onClick={onCancel}
              className="flex-1 rounded-xl border border-white/30 bg-white/10 backdrop-blur-md py-2.5 text-sm font-medium text-black"
            >
              {cancelText}
            </button>

            <button
              onClick={onConfirm}
              className="flex-1 rounded-xl bg-blue-600/90 backdrop-blur text-white py-2.5 text-sm font-semibold shadow-lg"
            >
              {confirmText}
            </button>
          </div>
        </div>
      ) : (
        <div className="w-full max-w-sm rounded-2xl bg-white shadow-2xl p-6 animate-fadeIn">

          {/* ICON */}
          <div className="text-3xl mb-3 text-center">{info.icon}</div>

          <h3 className="text-lg font-semibold text-slate-900 text-center">
            {title}
          </h3>

          <p className="mt-2 text-sm text-slate-600 text-center">
            {message}
          </p>

          {info.desc && (
            <p className={`mt-2 text-xs text-center ${info.color}`}>
              {info.desc}
            </p>
          )}

          <div className="mt-6 flex justify-end gap-3">
            <button
              onClick={onCancel}
              className="px-4 py-2 rounded-lg border border-slate-300 text-sm font-medium"
            >
              {cancelText}
            </button>

            <button
              onClick={onConfirm}
              className="px-4 py-2 rounded-lg bg-blue-600 text-white text-sm font-semibold"
            >
              {confirmText}
            </button>
          </div>
        </div>
      )}

    </div>,
    document.body
  );
}


// *************************************original working code*********************************************

// import { useEffect, useMemo, useRef, useState } from "react";
// import RegularLoader from "../../../../Component/Loader/RegularLoader";
// import { Input } from "./Input";
// import PhoneVerifyModal from "./PhoneVerifyModal";
// import { useNavigate } from "react-router-dom";
// import ImageUpload from "./ImageUpload";
// import ImeiScanner from "./ImeiScanner";
// import { BrowserMultiFormatReader } from "@zxing/browser";
// import toast from "react-hot-toast";
// import { scanImeiFromImage } from "./scanImeiFromImage";
// import { AlertCircle, AlertTriangle, Camera, Scan, ScanLine, Wallet } from "lucide-react";
// import { BASE_URL } from "../../../../config/api";
// import { form } from "framer-motion/client";
// import { cn } from "../Invoice/invoiceUtils";
// import { createPortal } from "react-dom";
// import { ValueLoader } from "../../../../Component/Common/ValueLoader";

// /* ===============================
//    FORM BODY
// ================================ */
// export const FormBody = ({
//   currentStep,   
//   form,
//   errors,
//   updateField,
//   existingCustomer,
//   onSearchModel,
//   modelResults = [],
//   modelLoading,
//   verifiedMobile,
//   categories = [],
//   categoriesLoading,
//   brands,
//   priceTemplates = [],
//   selectedTemplate,
//   setSelectedTemplate,
//   noTemplateMessage,
//   loading = false,
//   onViewTemplates, // ✅ NEW
//   onPincodeChange,
//   pinLoading,
//   handleImageUpload,
//   confirmed,
//   setConfirmed,
//   isPhoneVerified,
//   setIsPhoneVerified,
//   setCalculatedPayouts,
//   paymentConfig,
//   loadingPaymentConfig,
//   retailer,
//   retailerLoading,
//   setIsPayLater,
//   wCustomerId,
//   walletBalance,
//   walletLoading,
//   onNext,
// }) => {

//   console.log("retailer from user id : ", retailer)
//   const [showVerify, setShowVerify] = useState(false);
//   const Navigate = useNavigate();
//   const [showScanner, setShowScanner] = useState(false);
//   const [scanTarget, setScanTarget] = useState("deviceImei");
//   const [paymentSaving, setPaymentSaving] = useState(false);

//   const [expandAll, setExpandAll] = useState({});
//   const [expandedCoverage, setExpandedCoverage] = useState({});
//   const [useWallet, setUseWallet] = useState(false);
  

//   const [expanded, setExpanded] = useState({
//     features: false,
//     coverage: false,
//     exclusions: false,
//   });


//   const [confirmModal, setConfirmModal] = useState({
//     open: false,
//     type: null,
//   });
//   const [paymentSuccess, setPaymentSuccess] = useState(false);
//   const [payLaterSelected, setPayLaterSelected] = useState(false);
  

//   const [currentIndex, setCurrentIndex] = useState(0);

//   const [paymentKeys, setPaymentKeys] = useState({
//       key_id: "",
//       key_secret: ""
//     });

//   const [showProfitId, setShowProfitId] = useState(null);
//   const [openInfoId, setOpenInfoId] = useState(null);

//   const [showSettlement, setShowSettlement] = useState(false);
  
//     const [keyLoading, setKeyLoading] = useState(false);

//     const scrollRef = useRef(null);

// const scrollLeft = () => {
//   scrollRef.current?.scrollBy({ left: -350, behavior: "smooth" });
// };

// const scrollRight = () => {
//   scrollRef.current?.scrollBy({ left: 350, behavior: "smooth" });
// };

// const [direction, setDirection] = useState(0); 

// const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");

// const isRetailerMobile =
//   typeof window !== "undefined" &&
//   window.innerWidth < 640 &&
//   (authUser?.role === 5 || authUser?.role === 6);

// const handleNextCard = () => {
//   if (currentIndex < priceTemplates.length - 1) {
//     setDirection(1);
//     setCurrentIndex((prev) => prev + 1);
//   }
// };

// const handlePrevCard = () => {
//   if (currentIndex > 0) {
//     setDirection(-1);
//     setCurrentIndex((prev) => prev - 1);
//   }
// };

// const effectiveRetailerId =
//   Number(retailer?.role) === 6
//     ? retailer?.created_by_id
//     : retailer?.id;

// const effectivePromoterId =
//   Number(retailer?.role) === 6
//     ? retailer?.id
//     : null;

//     console.log("effectiveRetailerId: ", effectiveRetailerId)
//   const decodeBarcodeFromImage = async (file) => {
//   const reader = new BrowserMultiFormatReader();

//   const imageUrl = URL.createObjectURL(file);

//   try {
//     const result = await reader.decodeFromImageUrl(imageUrl);

//     const rawText = result.getText();
//     const imei = rawText.replace(/\D/g, "");

//     if (imei.length < 14 || imei.length > 16) {
//       throw new Error("Invalid IMEI barcode");
//     }

//     return imei;
//   } finally {
//     URL.revokeObjectURL(imageUrl);
//   }
// };

//   const [modelQuery, setModelQuery] = useState("");
//     let debounceTimer;
  
//     const MIN_CHARS = 3;

//     const handleModelChange = (e) => {
//       const value = e.target.value;
//       setModelQuery(value);
//       updateField("deviceModel", value);

//       clearTimeout(debounceTimer);

//       debounceTimer = setTimeout(() => {
//         if (value.trim().length >= MIN_CHARS) {
//           onSearchModel(value.trim());
//         } else {
//           onSearchModel(""); // 🔥 clear results when less than 3 chars
//         }
//       }, 400);
//     };

//   const filteredBrands = useMemo(() => {
//   if (!form.category) return [];

//   return brands.filter((brand) =>
//     brand.categories?.some(
//       (cat) => Number(cat.id) === Number(form.category)
//     )
//   );
// }, [brands, form.category]);

//   const getExpiryDate = (validityDays) => {
//     if (!validityDays) return "";

//     const today = new Date();
//     const expiry = new Date(today);
//     expiry.setDate(today.getDate() + Number(validityDays));

//     return expiry.toLocaleDateString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });
//   };

//   const product = selectedTemplate?.warranty_product;
//   console.log("selectedTemplate: ", selectedTemplate)
//   console.log("Product details: ", product)
//   const {
//     retailerPayout,
//     employeePayout,
//     otherpayout,
//     companypayout,
//     devicePrice,
//     TotalPayout,
//     retailerPending,
//     productPrice,
//   } = useMemo(() => {
//     const isPercent = Number(product?.is_percent) === 1;

//     // device price (MOP / selling price)
//     const devicePrice = Number(form?.mopPrice || 0);

//     // product price (MRP or % of device price)
//     const productPrice = isPercent
//       ? (Number(product?.mrp || 0) / 100) * devicePrice
//       : Number(product?.mrp || 0);

//     // payouts
//     const retailerPayout = isPercent
//       ? (Number(selectedTemplate?.retailer_payout || 0) / 100) * devicePrice
//       : Number(selectedTemplate?.retailer_payout || 0);

//     const employeePayout = isPercent
//       ? (Number(selectedTemplate?.emp_payout || 0) / 100) * devicePrice
//       : Number(selectedTemplate?.emp_payout || 0);

//     const otherpayout = isPercent
//       ? (Number(selectedTemplate?.other_payout || 0) / 100) * devicePrice
//       : Number(selectedTemplate?.other_payout || 0);
    
//     const companypayout = isPercent
//       ? (Number(selectedTemplate?.company_payout || 0) / 100) * devicePrice
//       : Number(selectedTemplate?.company_payout || 0);

//     // const TotalPayout = retailerPayout + employeePayout
//     const TotalPayout = retailerPayout
//     // pending for retailer
//     const retailerPending = Math.max(
//       0,
//       productPrice - TotalPayout
//     );

//     return {
//       retailerPayout,
//       employeePayout,
//       devicePrice,
//       companypayout,
//       otherpayout,
//       retailerPending,
//       productPrice,
//       TotalPayout,
//     };
//   }, [selectedTemplate, product, form?.mopPrice]);

//     useEffect(() => {
//     if (!selectedTemplate) return;

//     setCalculatedPayouts({
//       retailerPayout,
//       employeePayout,
//       otherpayout,
//       companypayout,
//       productPrice,
//       retailerPending
//     });
//   }, [
//     retailerPayout,
//     employeePayout,
//     productPrice,
//     selectedTemplate,
//   ]);

//   const walletDisabled = walletBalance < retailerPending;

//   const features = useMemo(() => {
//     const raw = product?.features || "";
//     return raw
//       .split(".")
//       .map((f) => f.trim())
//       .filter(Boolean);
//   }, [product?.features]);

//   const coverage = useMemo(() => {
//     const raw = product?.coverage || "";
//     return raw
//       .split(".")
//       .map((c) => c.trim())
//       .filter(Boolean);
//   }, [product?.coverage]);

//   const exclusions = useMemo(() => {
//     const raw = product?.exclusions || "";
//     return raw
//       .split(".")
//       .map((e) => e.trim())
//       .filter(Boolean);
//   }, [product?.exclusions]);

//   const paymentButtons = useMemo(() => {
//   if (!paymentConfig) {
//     return { showPayNow: false, showPayLater: false };
//   }

//   const {
//     pay_now,
//     pay_later,
//     admin_paynow_status,
//     admin_paylater_status,
//   } = paymentConfig;

//   // 🔥 ADMIN OVERRIDE RULES (TOP PRIORITY)
//   if (admin_paylater_status === 1) {
//     return { showPayNow: true, showPayLater: true };
//   }

//   if (admin_paynow_status === 1) {
//     return { showPayNow: true, showPayLater: false };
//   }

//   // 🔽 USER DEFAULT RULES
//   if (pay_later === 1) {
//     return { showPayNow: true, showPayLater: true };
//   }

//   if (pay_now === 1) {
//     return { showPayNow: true, showPayLater: false };
//   }

//   return { showPayNow: false, showPayLater: false };
// }, [paymentConfig]);


// const fetchPaymentKeys = async () => {
//   try {
//     setKeyLoading(true);

//     const res = await fetch(`${BASE_URL}payment/keys`);
//     const data = await res.json();

//     if (Array.isArray(data) && data.length > 0) {
//       setPaymentKeys({
//         key_id: data[0].key_id,
//         key_secret: data[0].key_secret
//       });
//     } else {
//       console.error("Invalid keys response", data);
//     }
//   } catch (err) {
//     console.error("Failed to fetch payment keys", err);
//   } finally {
//     setKeyLoading(false);
//   }
// };

//   useEffect(() => {
//   if (currentStep === 4) {
//     fetchPaymentKeys();
//   }
// }, [currentStep]);

// const resolvedCustomerId = existingCustomer?.id || wCustomerId;

// const notes = {
//     project: "warranty",
//     service: "activation",
//     imei1: form.deviceImei,
//     imei2:form.deviceImei2,
//     serial: form.serialNumber,
//     product_id: selectedTemplate?.warranty_product_id,
//     model_id: form.modelId,  
//     company_id: retailer?.company_id,
//     retailer_id: effectiveRetailerId,
//     // agent_id: retailer?.agent_id,
//     amount: retailerPending,
//     w_customer_id: resolvedCustomerId,
//     created_by: retailer?.id,
//     document_url: form.billPhoto,
//     link1: form.devicePhoto,
//     zoho_id: authUser?.zoho_id || null,
// }

//   const handlePayNow = async () => {
//   const money = (val) => Number(val).toFixed(2);
  
//   if (useWallet) {
//      setPaymentSaving(true); 

//       try {
//         const payload = {
//           // DEVICE + PRODUCT
//           name: product?.name,
//           imei1: form.deviceImei,
//           imei2: form.deviceImei2 || "",
//           serial: form.serialNumber || "",

//           brand_id: Number(form.deviceBrand),
//           brand_name: form.brandName,
//           category_id: Number(form.category),
//           category_name: form.categoryName,

//           product_id: product?.id,
//           product_name: product?.name,

//           model: form.deviceModel,
//           model_id:form.modelId,

//           // PRICING
//           device_price: Number(form.mopPrice),
//           product_price: Number(money(retailerPending)),
//           product_mrp: Number(product?.mrp),

//           // WARRANTY
//           available_claim: product?.claims,
//           expiry_date: form.expiryDate,

//           // USERS
//           company_id: retailer.company_id,
//           retailer_id: effectiveRetailerId,
//           w_customer_id: resolvedCustomerId,
          

//           retailer_payout: retailer.retailer_payout,
//           employee_payout: retailer.employee_payout,
//           other_payout: retailer.other_payout,
//           company_payout: retailer.company_payout,

//           // META
//           agent_id: retailer.agent_id || null,
//           created_by: retailer.id,
//           created_by_name: retailer?.business_name,
//           promoter_id: effectivePromoterId,
//           zoho_product_id: product?.zoho_product_id,
//           amount: Number(money(retailerPending)),
//           is_pay_later: 0,

//           document_url: form.billPhoto,
//           link1: form.devicePhoto,
//           link2: form.customerPhoto,
          
//           credit_amount: Number(money(retailerPending)),
//           is_from_wallet: 1,
//         };

//         const res = await fetch(
//           `${BASE_URL}warranty/create-warranty-with-credit`,
//           {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json"
//             },
//             body: JSON.stringify(payload)
//           }
//         );

//         const data = await res.json();

//         if (!data.success) {
//           toast.error(data.message || "Wallet payment failed");
//           return;
//         }

//         toast.success(data.message || "Warranty activated using wallet");
//         setPaymentSuccess(true);
//         setConfirmed(true);

//         // auto activate warranty
//         setTimeout(() => {
//           onNext();
//         }, 500);

//       } catch (err) {
//         toast.error("Wallet payment failed");
//       }finally {
//         setPaymentSaving(false);   // 🔓 HIDE LOADER
//       }
//       return;
//     }

//   if (!paymentKeys?.key_id) {
//     toast.error("Payment keys not loaded");
//     return;
//   }

//   const roundedAmount = Math.round(Number(retailerPending) * 100);
//   // console.log("rounded amount: ", roundedAmount)
//   const options = {
//     key: paymentKeys.key_id,
//     amount: roundedAmount, // ₹1 for now (paise)
//     currency: "INR",
//     name: "Warranty Mitra",
//     description: product?.name || "Warranty Payment",
//     notes: notes,

//     handler: async function (response) {
//       try {
//         setPaymentSaving(true); // 🔒 LOCK UI

//         console.log("Razorpay Success:", response);

//         // ✅ BUILD PAYLOAD (FOR FUTURE USE)
//         const payload = {
//           payment_id: response.razorpay_payment_id,

//           // DEVICE + PRODUCT
//           name: product?.name,
//           imei1: form.deviceImei,
//           imei2: form.deviceImei2 || "",
//           serial: form.serialNumber || "",

//           brand_id: Number(form.deviceBrand),
//           category_id: Number(form.category),
//           product_id: product?.id,
//           product_name: product?.name,
//           brand_name: form.brandName,
//           category_name: form.categoryName,
//           model: form.deviceModel,

//           // WARRANTY
//           available_claim: product?.claims,
//           expiry_date: form.expiryDate,

//           // USERS
//           w_customer_id: existingCustomer?.id,
//           retailer_id: effectiveRetailerId,
//           agent_id: retailer.agent_id || null,

//           // PRICING
//           device_price: Number(form.mopPrice),
//           product_price: retailerPending,
//           product_mrp: Number(product?.mrp),

//           retailer_payout: retailer.retailer_payout,
//           employee_payout: retailer.employee_payout,
//           other_payout: retailer.other_payout,
//           company_payout: retailer.company_payout,

//           // META
//           company_id: retailer.company_id,
//           created_by: retailer.id,
//           created_by_name: retailer?.business_name,
//           zoho_product_id: product?.zoho_product_id,
//           amount: retailerPending,
//         };

//         console.log("Payment Payload (not sent):", payload);

//         // ❌ API CALL INTENTIONALLY DISABLED
//         /*
//         const res = await fetch(`${BASE_URL}warranty/payment-flow`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         });

//         const data = await res.json();

//         if (!res.ok || !data?.status) {
//           toast.error("Payment done but warranty activation failed");
//           return;
//         }
//         */

//         // ✅ TEMP SUCCESS (PAYMENT ONLY)
//         toast.success("Payment successful 🎉");
//         setPaymentSuccess(true);

//         setConfirmed(true);

//         // auto activate warranty
//         setTimeout(() => {
//           onNext();
//         }, 500);
//       } catch (err) {
//         console.error(err);
//         toast.error("Payment succeeded but processing failed");
//       } finally {
//         setPaymentSaving(false); // 🔓 UNLOCK UI
//       }
//     },

//     prefill: {
//       name: form.name || "",
//       email: form.email || "",
//       contact: form.mobile || "",
//     },

//     theme: { color: "#2563eb" },
//   };

//   const rzp = new window.Razorpay(options);
//   rzp.open();
// };

// const hideWalletForRetailerUser =
//   Number(retailer?.role) === 6 &&
//   (!retailer?.allow_wallet || Number(retailer?.allow_wallet) === 0);
// // const handlePayNow = async () => {
// //   if (!paymentKeys?.key_id) {
// //     toast.error("Payment keys not loaded");
// //     return;
// //   }

// //   const options = {
// //     key: paymentKeys.key_id,
// //     amount: 1 * 100, // Razorpay works in paise
// //     currency: "INR",
// //     name: "Warranty Mitra",
// //     description: product?.name || "Warranty Payment",
// //     notes:notes,

// //     handler: async function (response) {
// //       setPaymentSaving(true); // 🔒 FULL PAGE LOCK

// //       const payload = {
// //         payment_id: response.razorpay_payment_id,

// //         // DEVICE + PRODUCT
// //         name: product?.name,
// //         imei1: form.deviceImei,
// //         imei2: form.deviceImei2 || "",
// //         serial: form.serialNumber || "",

// //         brand_id: Number(form.deviceBrand),
// //         category_id: Number(form.category),
// //         product_id: product?.id,
// //         product_name: product?.name,
// //         brand_name: form.brandName,
// //         category_name: form.categoryName,
// //         model: form.deviceModel,

// //         // WARRANTY
// //         available_claim: product?.claims,
// //         expiry_date: form.expiryDate,

// //         // USERS
// //         w_customer_id: existingCustomer?.id,
// //         retailer_id: retailer.id,
// //         agent_id: retailer.agent_id || null,

// //         // PRICING
// //         device_price: Number(form.mopPrice),
// //         product_price: retailerPending,
// //         product_mrp: Number(product?.mrp),

// //         retailer_payout: retailer.retailer_payout,
// //         employee_payout: retailer.employee_payout,
// //         other_payout: retailer.other_payout,
// //         company_payout: retailer.company_payout,

// //         // META
// //         company_id: retailer.company_id,
// //         created_by: retailer.id,
// //         zoho_product_id: product?.zoho_product_id,
// //         amount: retailerPending,
// //       };

// //       try {
// //         const res = await fetch(
// //           `${BASE_URL}warranty/payment-flow`,
// //           {
// //             method: "POST",
// //             headers: { "Content-Type": "application/json" },
// //             body: JSON.stringify(payload),
// //           }
// //         );

// //         const data = await res.json();

// //         if (!res.ok || !data?.status) {
// //           toast.error("Payment done but warranty activation failed");
// //           return;
// //         }

// //         toast.success("Payment successful & warranty activated 🎉");
// //         // Navigate("/warranty/success");
// //       } catch (err) {
// //         console.error(err);
// //         toast.error("Payment succeeded but server failed");
// //       } finally {
// //         setPaymentSaving(false); // 🔓 UNLOCK PAGE
// //       }
// //     },

// //     prefill: {
// //       name: form.name ,
// //       email: form.email ,
// //       contact: form.mobile,
// //     },

// //     theme: { color: "#2563eb" },
// //   };

// //   const rzp = new window.Razorpay(options);
// //   rzp.open();
// // };

//   /* ================= STEP 1 : PRICING ================= */

//   const glassCard = isRetailerMobile
//   ? "bg-white/10 backdrop-blur-2xl border border-white/30 shadow-[0_20px_50px_rgba(31,38,135,0.25)]"
//   : "bg-white border border-slate-200 shadow-lg";

//   if (currentStep === 1) {
//  const canViewTemplates =
//   form.categoryName &&
//   form.brandName &&
//   form.deviceModel &&
//   form.mopPrice;

  

//   return (
//     <div
//       className={cn(
//         "space-y-6 p-4 rounded-2xl transition-all duration-300",
//         isRetailerMobile ? glassCard : ""
//       )}
//     >

//       {/* ================= CATEGORY + BRAND + MODEL + PRICE ================= */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

//         <div className="relative">
//           <Input
//             label="Search Model"
//             value={form.deviceModel}
//             onChange={handleModelChange}
//             error={errors.deviceModel}
//             placeholder="search model"
//           />

//           {modelQuery.length > 0 && modelQuery.length < 3 && (
//             <p className="mt-1 text-xs text-slate-500">
//               Type at least 3 characters to search
//             </p>
//           )}

//           {/* DROPDOWN */}
//           {modelLoading && (
//             <div className={cn(
//                 "absolute z-10 mt-1 w-full rounded-xl p-2 text-sm",
//                 isRetailerMobile
//                   ? "bg-white/20 backdrop-blur-xl border border-white/30 text-white"
//                   : "bg-white border"
//               )}>
//               Loading...
//             </div>
//           )}

//           {!modelLoading &&
//             modelQuery.trim().length >= 3 &&
//               modelResults.length === 0 && (
//               <div className="absolute z-10 mt-1 w-full rounded-lg border border-slate-200 bg-white p-3 text-center text-sm text-slate-500">
//                 No model found. Search for a different model.
//               </div>
//           )}

//           {!modelLoading && modelResults.length > 0 && (
//             <ul className={cn("absolute z-10 mt-1 w-full border rounded-lg shadow max-h-[280px] overflow-y-auto" , isRetailerMobile ? "bg-blue-100 font-semibold" : " bg-white" )}>
//               {modelResults.map((model) => (
//                 <li
//                   key={model.id}
//                   onClick={() => {
//                       updateField(
//                         "deviceModel",
//                         `${model.name}${model.storage ? " - " + model.storage : ""}`
//                       );
//                       updateField("modelId", model.id);   
//                       updateField("category", String(model.category.id));
//                       updateField("categoryName", model.category.name);
//                       updateField("deviceBrand", String(model.brand.id));
//                       updateField("brandName", model.brand.name);
//                       updateField("mopPrice", model.price);

//                       setModelQuery("");      // ✅ IMPORTANT
//                       onSearchModel("");      // clear results
//                     }}


//                   className="px-3 py-2 text-sm cursor-pointer hover:bg-blue-50 font-semibold"
//                 >
//                   {model.name} - {model.storage}
//                 </li>
//               ))}
//             </ul>
//           )}

          
//         </div>

//         {/* CATEGORY */}
//           <div className="flex flex-col gap-1">
//             <label className="text-sm font-medium">Category</label>
//             <Input
//               value={form.categoryName}
//               disabled
//               placeholder="Auto-filled from model"
//             />
//           </div>


//           {/* BRAND */}
//           <div className="flex flex-col gap-1">
//             <label className="text-sm font-medium">Brand</label>
//             <Input
//               value={form.brandName}
//               disabled
//               placeholder="Auto-filled from model"
//             />
//           </div>

//         <Input
//           label="MOP Price (₹)"
//           type="number"
//           value={form.mopPrice}
//           disabled
//           placeholder="Auto-filled from model"
//         />
//       </div>

//       {/* ================= VIEW TEMPLATES BUTTON ================= */}
//       <button
//         onClick={onViewTemplates}
//         disabled={!canViewTemplates || loading}
//         className={`px-6 py-2 rounded-lg text-sm font-medium
//           ${
//             canViewTemplates
//               ? "bg-blue-600 text-white hover:bg-blue-700"
//               : "bg-slate-200 text-slate-500 cursor-not-allowed"
//           }`}
//       >
//         {loading ? "Loading..." : "Get Products"}
//       </button>

//       {/* NO TEMPLATE MESSAGE */}
//       {!loading && noTemplateMessage && (
//         <div className="mt-6 flex justify-center">
//           <div className="w-full max-w-md rounded-2xl border border-amber-200 bg-amber-50 p-6 text-center">
//             <div className="text-amber-700 text-sm font-semibold">
//               {noTemplateMessage}
//             </div>
//             <p className="mt-1 text-xs text-amber-600">
//               Try changing device price or selecting a different model.
//             </p>
//           </div>
//         </div>
//       )}

//       {/* ================= DESKTOP GRID ================= */}
// {priceTemplates.length > 0 && (
//   <div className="hidden md:grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//     {priceTemplates.map((tpl) => {
//       const product = tpl.warranty_product;

//       const isPercent = Number(product?.is_percent) === 1;
//       const mopPrice = Number(form?.mopPrice || 0);

//       const effectiveMrp = isPercent
//         ? Math.round((Number(product?.mrp || 0) / 100) * mopPrice)
//         : Number(product?.mrp || 0);

//       const effectiveMargin = isPercent
//         ? Math.round((Number(tpl?.retailer_payout || 0) / 100) * mopPrice)
//         : Number(tpl?.retailer_payout || 0);

//       return (
//         <div
//           key={tpl.id}
//           onClick={() => {
//             setSelectedTemplate(tpl);

//             const expiryDate = new Date();
//             expiryDate.setDate(
//               expiryDate.getDate() +
//                 Number(tpl.warranty_product?.validity || 0)
//             );

//             updateField(
//               "expiryDate",
//               expiryDate.toISOString().split("T")[0]
//             );
//           }}
//           className={`relative cursor-pointer overflow-hidden rounded-3xl border transition-all duration-300
//             ${
//               selectedTemplate?.id === tpl.id
//                 ? "border-blue-600 bg-blue-50 shadow-2xl scale-[1.03] ring-2 ring-blue-300"
//                 : "border-slate-200 bg-white hover:shadow-lg"
//             }
//           `}
//                   >

//           {selectedTemplate?.id === tpl.id && (
//               <div className="absolute top-3 left-3 z-30 bg-blue-600 text-white rounded-full px-3 py-1 text-[10px] font-semibold shadow-lg animate-pulse">
//                 ✓ Selected
//               </div>
//             )}

//           <div
//             onClick={(e) => {
//               e.stopPropagation();
//               setOpenInfoId(openInfoId === tpl.id ? null : tpl.id);
//             }}
//             className="absolute top-3 right-3 z-20 h-8 w-8 rounded-full bg-white shadow-md border flex items-center justify-center cursor-pointer hover:bg-blue-50 transition"
//           >
//             <span className="text-blue-600 text-sm font-bold">i</span>
//           </div>
//           {/* 🔷 TOP CURVED GRADIENT */}
//                 <div className="relative h-20 bg-gradient-to-br from-blue-500 via-sky-400 to-indigo-500">
//                   <svg
//                     className="absolute bottom-0 w-full"
//                     viewBox="0 0 1440 120"
//                     preserveAspectRatio="none"
//                   >
//                     <path
//                       fill="#ffffff"
//                       d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,42.7C1120,32,1280,32,1360,32L1440,32L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z"
//                     />
//                   </svg>
//                 </div>

//                 {/* 💲 PRICE BADGE */}
//                 <div className="absolute top-7 left-1/2 -translate-x-1/2 z-10">
//                   <div className="w-20 h-20 rounded-full bg-white shadow-lg border flex items-center justify-center overflow-hidden">
//                     {product?.image ? (
//                       <img
//                         src={product.image}
//                         alt={product.name}
//                         className="w-full h-full object-contain p-2"
//                       />
//                     ) : (
//                       <span className="text-xs text-slate-400">No Image</span>
//                     )}
//                   </div>
//                 </div>


//                 {/* CONTENT */}
//                 <div className="pt-10 px-5 pb-6 text-center">
//                   {/* IMAGE */}
//                   {/* <div className="mx-auto mb-3 w-16 h-16 rounded-xl border bg-white flex items-center justify-center overflow-hidden">
//                     {product?.image ? (
//                       <img
//                         src={product.image}
//                         alt={product.name}
//                         className="w-full h-full object-contain"
//                       />
//                     ) : (
//                       <span className="text-xs text-slate-400">No Image</span>
//                     )}
//                   </div> */}

//                   {/* TITLE */}
//                   <h3 className="text-sm font-bold uppercase tracking-wide text-blue-600">
//                     {product?.name}
//                   </h3>
//                   <p className="text-xs text-slate-500 mt-1">
//                     Valid Upto: {getExpiryDate(product?.validity)}
//                   </p>

//                   {/* INFO */}
//                   <div className="flex justify-center gap-2 items-center py-2 text-sm text-slate-700">
//                     <p> 
//                       MRP:{" "} 
//                       <span className="font-semibold">
//                         ₹{effectiveMrp} 
//                         {/* {isPercent && ( <span className="text-[11px] text-slate-500 ml-1"> ({product?.mrp}% of ₹{form?.mopPrice}) </span> )} */} 
//                       </span> 
//                     </p>

//                    {/* <div
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         setShowProfitId(showProfitId === tpl.id ? null : tpl.id);
//                       }}
//                       className={`mt-3 cursor-pointer rounded-xl border px-2 py-1 text-center transition-all duration-300
//                         ${
//                           showProfitId === tpl.id
//                             ? "border-blue-500 bg-blue-50 shadow-md"
//                             : "border-slate-200 bg-slate-50 hover:bg-slate-100"
//                         }
//                       `}
//                     >
//                       <p className="text-xs font-medium text-slate-700 uppercase tracking-wide">
//                         Profit
//                       </p>

//                       <p className="mt-1 text-xs font-semibold text-blue-600">
//                         {showProfitId === tpl.id ? `₹${effectiveMargin}` : "Tap to Reveal"}
//                       </p>
//                     </div> */}

//                   </div>

//                   {/* META */}
//                   <div className="mt-3 grid grid-cols-2 gap-3 text-xs">
//                     <div className="rounded-xl border bg-emerald-50 py-2">
//                       <p className="text-emerald-600 font-semibold">Validite</p>
//                       <p className="font-bold">{product?.validity} days</p>
//                     </div>

//                     <div className="rounded-xl border bg-violet-50 py-2">
//                       <p className="text-violet-600 font-semibold">Upto Claims</p>
//                       <p className="font-bold">{product?.claims}</p>
//                     </div>
//                   </div>

//                   {/* FEATURES */}
//                   <div className="mt-5 text-left">
//                   <p className="text-xs font-semibold text-blue-700 mb-2">
//                     Features
//                   </p>

//                   {product?.features ? (() => {
//                     const features = product.features.split(".").map(f => f.trim()).filter(Boolean);
//                     const isExpanded = expandAll[tpl.id];

//                     const visibleFeatures = isExpanded ? features : features.slice(0, 2);

//                     return (
//                       <>
//                         <ul className="space-y-1">
//                           {visibleFeatures.map((f, i) => (
//                             <li key={i} className="flex gap-2 text-sm text-slate-700">
//                               {f}
//                             </li>
//                           ))}
//                         </ul>

//                         {features.length > 2 && (
//                           <button
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               setExpandAll(prev => ({
//                                 ...prev,
//                                 [tpl.id]: !prev[tpl.id],
//                               }));
//                             }}
//                             className="mt-2 text-xs font-semibold text-blue-600 underline"
//                           >
//                             {isExpanded ? "View less" : "View more"}
//                           </button>
//                         )}
//                       </>
//                     );
//                   })() : (
//                     <p className="text-xs text-slate-400 italic">
//                       No features available
//                     </p>
//                   )}
//                 </div>

//                   {/* COVERAGE */}
//                   <div className="mt-4 text-left">
//                     <p className="text-xs font-semibold text-blue-700 mb-2">
//                       Coverage
//                     </p>

//                     {product?.coverage ? (() => {
//                       const coverage = product.coverage.split(".").map(f => f.trim()).filter(Boolean);
//                       const isExpanded = expandedCoverage[tpl.id];

//                       const visibleCoverage = isExpanded ? coverage : coverage.slice(0, 2);

//                       return (
//                         <>
//                           <ul className="space-y-1">
//                             {visibleCoverage.map((f, i) => (
//                               <li key={i} className="flex gap-2 text-sm text-slate-700">
//                                 <span className="text-emerald-500 font-bold">✔</span>
//                                 {f}
//                               </li>
//                             ))}
//                           </ul>

//                           {coverage.length > 2 && (
//                             <button
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 setExpandedCoverage(prev => ({
//                                   ...prev,
//                                   [tpl.id]: !prev[tpl.id],
//                                 }));
//                               }}
//                               className="mt-2 text-xs font-semibold text-blue-600 underline"
//                             >
//                               {isExpanded ? "View less" : "View more"}
//                             </button>
//                           )}
//                         </>
//                       );
//                     })() : (
//                       <p className="text-xs text-slate-400 italic">
//                         No coverage available
//                       </p>
//                     )}
//                   </div>
//                 </div>

//                 {openInfoId === tpl.id && (
//                   <div
//                     onClick={(e) => e.stopPropagation()}
//                     className="absolute top-12 right-4 w-56 rounded-2xl border border-blue-200 bg-white shadow-xl p-4 z-30 animate-fadeIn"
//                   >
//                     <p className="text-xs font-semibold text-slate-600 mb-3 uppercase tracking-wide">
//                       Price Breakdown
//                     </p>

//                     <div className="space-y-2 text-sm">
//                       <div className="flex justify-between">
//                         <span className="text-slate-500">MRP</span>
//                         <span className="font-semibold text-slate-900">
//                           ₹{effectiveMrp}
//                         </span>
//                       </div>

//                       <div className="flex justify-between">
//                         <span className="text-slate-500">Profit</span>
//                         <span className="font-semibold text-blue-600">
//                           ₹{effectiveMargin}
//                         </span>
//                       </div>

//                       <div className="border-t pt-2 flex justify-between">
//                         <span className="text-slate-600 font-medium">Payable</span>
//                         <span className="font-bold text-amber-600">
//                           ₹{effectiveMrp - effectiveMargin}
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                 )}

//         </div>
//       );
//     })}
//   </div>
// )}

      
//       {/* ================= MOBILE SLIDER ================= */}
// {priceTemplates.length > 0 && (
//   <div className="md:hidden relative w-full overflow-hidden px-2">

//     {/* LEFT */}
//     {/* <button
//       onClick={handlePrevCard}
//       disabled={currentIndex === 0}
//       className={cn(
//         "absolute top-1/2 -translate-y-1/2 left-1 z-30 p-2 rounded-full shadow-lg",
//         isRetailerMobile
//           ? "bg-white/80 backdrop-blur-md border border-white/60 text-black"
//           : "bg-blue-700 text-white",
//         "disabled:opacity-50"
//       )}
//     >
//       ◀
//     </button> */}

//     {/* CARD */}
//     {/* <div className="w-full max-w-sm overflow-hidden relative"> */}
//     <div
//   className="flex  overflow-x-auto snap-x snap-mandatory scroll-smooth no-scrollbar"
// >
//     {priceTemplates.map((tpl) => {
//       const product = tpl.warranty_product;

//       const isPercent = Number(product?.is_percent) === 1;
//       const mopPrice = Number(form?.mopPrice || 0);

//       const effectiveMrp = isPercent
//         ? Math.round((Number(product?.mrp || 0) / 100) * mopPrice)
//         : Number(product?.mrp || 0);

//       const effectiveMargin = isPercent
//         ? Math.round((Number(tpl?.retailer_payout || 0) / 100) * mopPrice)
//         : Number(tpl?.retailer_payout || 0);

//       return (
//         <div key={tpl.id} className="w-[85%] flex-shrink-0 p-2 snap-center">

//           <div
//             onClick={() => {
//               setSelectedTemplate(tpl);

//               const expiryDate = new Date();
//               expiryDate.setDate(
//                 expiryDate.getDate() +
//                   Number(tpl.warranty_product?.validity || 0)
//               );

//               updateField(
//                 "expiryDate",
//                 expiryDate.toISOString().split("T")[0]
//               );
//             }}
//             className={cn(
//               "relative cursor-pointer overflow-hidden rounded-3xl transition-all duration-300",
//               isRetailerMobile
//                 ? selectedTemplate?.id === tpl.id
//                   ? "glass-small-card border-white/40 bg-white/20 shadow-2xl scale-[1.03] ring-2 ring-white/40"
//                   : "glass-small-card border-white/30 bg-white/10"
//                 : selectedTemplate?.id === tpl.id
//                   ? "border-blue-600 bg-blue-50 shadow-2xl scale-[1.03] ring-2 ring-blue-300"
//                   : "border-slate-200 bg-white hover:shadow-lg"
//             )}
//           >

//               {/* SELECTED BADGE */}
//               {selectedTemplate?.id === tpl.id && (
//                 <div className="absolute top-5 left-5 z-30 bg-white text-blue-600 rounded-full px-3 py-1 text-[10px] font-semibold shadow-lg animate-pulse">
//                   ✓ Selected
//                 </div>
//               )}
//               {/* INFO ICON */}
//               <div
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   setOpenInfoId(openInfoId === tpl.id ? null : tpl.id);
//                 }}
//                 className={cn(
//                     "absolute top-5 right-5 z-30 h-8 w-8 rounded-full flex items-center justify-center cursor-pointer transition",
//                     isRetailerMobile
//                       ? "bg-white/80 backdrop-blur-md border border-white/30 text-white"
//                       : "bg-white shadow-md border"
//                   )}
//               >
//                 <span className="text-blue-600 text-sm font-bold">i</span>
//               </div>

//               {/* PRICE POPUP */}
//               {openInfoId === tpl.id && (
//                 <div
//                   onClick={(e) => e.stopPropagation()}
//                   className={cn(
//                     "absolute top-12 right-4 w-60 rounded-2xl p-4 z-40 animate-fadeIn",
//                     isRetailerMobile
//                       ? "bg-white/90 backdrop-blur-xl border border-white/30 text-white"
//                       : "bg-white shadow-xl border border-blue-200"
//                   )}
//                 >
//                   <p className="text-xs font-semibold text-slate-600 mb-3 uppercase tracking-wide">
//                     Price Breakdown
//                   </p>

//                   <div className="space-y-2 text-sm">
//                     <div className="flex justify-between">
//                       <span className="text-slate-500">MRP</span>
//                       <span className="font-semibold text-slate-900">
//                         ₹{effectiveMrp}
//                       </span>
//                     </div>

//                     <div className="flex justify-between">
//                       <span className="text-slate-500">Profit</span>
//                       <span className="font-semibold text-blue-600">
//                         ₹{effectiveMargin}
//                       </span>
//                     </div>

//                     <div className="border-t pt-2 flex justify-between">
//                       <span className="text-slate-600 font-medium">Payable</span>
//                       <span className="font-bold text-amber-600">
//                         ₹{effectiveMrp - effectiveMargin}
//                       </span>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* TOP GRADIENT */}
//               <div
//                 className={`relative h-20 transition-all duration-300 ${
//                   selectedTemplate?.id === tpl.id
//                     ? "bg-gradient-to-br from-blue-700 via-blue-600 to-indigo-700"
//                     : "bg-gradient-to-br from-blue-500 via-sky-400 to-indigo-500"
//                 }`}
//               >
//                 <svg
//                   className="absolute bottom-0 w-full"
//                   viewBox="0 0 1440 120"
//                   preserveAspectRatio="none"
//                 >
//                   <path
//                     fill={isRetailerMobile ? "rgba(255,255,255,0.15)" : "#ffffff"}
//                     d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,42.7C1120,32,1280,32,1360,32L1440,32L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z"
//                   />
//                 </svg>
//               </div>

//                   {/* 💲 PRICE BADGE */}
//                   <div className="absolute top-7 left-1/2 -translate-x-1/2 z-10">
//                     <div className="w-20 h-20 rounded-full bg-white shadow-lg border flex items-center justify-center overflow-hidden">
//                       {product?.image ? (
//                         <img
//                           src={product.image}
//                           alt={product.name}
//                           className="w-full h-full object-contain p-2"
//                         />
//                       ) : (
//                         <span className="text-xs text-slate-400">No Image</span>
//                       )}
//                     </div>
//                   </div>

//                   {/* CONTENT */}
//                   <div className="pt-7 px-5 pb-6 text-center">
//                     {/* IMAGE */}
//                     {/* <div className="mx-auto mb-3 w-16 h-16 rounded-xl border bg-white flex items-center justify-center overflow-hidden">
//                       {product?.image ? (
//                         <img
//                           src={product.image}
//                           alt={product.name}
//                           className="w-full h-full object-contain"
//                         />
//                       ) : (
//                         <span className="text-xs text-slate-400">No Image</span>
//                       )}
//                     </div> */}

//                     {/* TITLE */}
//                     <h3 className="text-sm font-bold uppercase tracking-wide text-blue-600">
//                       {product?.name}
//                     </h3>
//                     <p className="text-xs text-slate-500 mt-1">
//                       Valid Upto: {getExpiryDate(product?.validity)}
//                     </p>

//                     {/* INFO */}
//                     <div className="flex justify-center gap-2 items-center py-2 text-sm text-slate-700">
//                       <p>
//                         MRP:{" "}
//                         <span className="font-semibold">
//                           ₹{effectiveMrp}
//                           {/* {isPercent && (
//                             <span className="text-[11px] text-slate-500 ml-1">
//                               ({product?.mrp}% of ₹{form?.mopPrice})
//                             </span>
//                           )} */}
//                         </span>
//                       </p>

//                       <p>
//                         Margin:{" "}
//                         <span className="font-semibold">
//                           ₹{effectiveMargin}
//                           {/* {isPercent && (
//                             <span className="text-[11px] text-slate-500 ml-1">
//                               ({tpl?.retailer_payout}% of ₹{form?.mopPrice})
//                             </span>
//                           )} */}
//                         </span>
//                       </p>
//                     </div>

//                     {/* META */}
//                     <div className="mt-4 grid grid-cols-2 gap-3 text-xs">
//                       <div className="rounded-xl border bg-emerald-50 py-2">
//                         <p className="text-emerald-600 font-semibold">Validite</p>
//                         <p className="font-bold">{product?.validity} days</p>
//                       </div>

//                       <div className="rounded-xl border bg-violet-50 py-2">
//                         <p className="text-violet-600 font-semibold">Upto Claims</p>
//                         <p className="font-bold">{product?.claims}</p>
//                       </div>
//                     </div>

//                     {/* FEATURES */}
//                     <div className="mt-5 text-left">
//                       <p className="text-xs font-semibold text-blue-700 mb-2">
//                         Features
//                       </p>

//                       {product?.features ? (() => {
//                         const features = product.features.split(".").map(f => f.trim()).filter(Boolean);
//                         const isExpanded = expandAll[tpl.id];

//                         const visibleFeatures = isExpanded ? features : features.slice(0, 2);

//                         return (
//                           <>
//                             <ul className="space-y-1">
//                               {visibleFeatures.map((f, i) => (
//                                 <li key={i} className="flex gap-2 text-sm text-slate-700">
//                                   {f}
//                                 </li>
//                               ))}
//                             </ul>

//                             {features.length > 2 && (
//                               <button
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   setExpandAll(prev => ({
//                                     ...prev,
//                                     [tpl.id]: !prev[tpl.id],
//                                   }));
//                                 }}
//                                 className="mt-2 text-xs font-semibold text-blue-600 underline"
//                               >
//                                 {isExpanded ? "View less" : "View more"}
//                               </button>
//                             )}
//                           </>
//                         );
//                       })() : (
//                         <p className="text-xs text-slate-400 italic">
//                           No features available
//                         </p>
//                       )}
//                     </div>

//                     {/* COVERAGE */}
//                     <div className="mt-4 text-left">
//                       <p className="text-xs font-semibold text-blue-700 mb-2">
//                         Coverage
//                       </p>

//                       {product?.coverage ? (() => {
//                         const coverage = product.coverage.split(".").map(f => f.trim()).filter(Boolean);
//                         const isExpanded = expandedCoverage[tpl.id];

//                         const visibleCoverage = isExpanded ? coverage : coverage.slice(0, 2);

//                         return (
//                           <>
//                             <ul className="space-y-1">
//                               {visibleCoverage.map((f, i) => (
//                                 <li key={i} className="flex gap-2 text-sm text-slate-700">
//                                   <span className="text-emerald-500 font-bold">✔</span>
//                                   {f}
//                                 </li>
//                               ))}
//                             </ul>

//                             {coverage.length > 2 && (
//                               <button
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   setExpandedCoverage(prev => ({
//                                     ...prev,
//                                     [tpl.id]: !prev[tpl.id],
//                                   }));
//                                 }}
//                                 className="mt-2 text-xs font-semibold text-blue-600 underline"
//                               >
//                                 {isExpanded ? "View less" : "View more"}
//                               </button>
//                             )}
//                           </>
//                         );
//                       })() : (
//                         <p className="text-xs text-slate-400 italic">
//                           No coverage available
//                         </p>
//                       )}
//                     </div>
//                   </div>
//             </div>
//           </div>
//           );
//         })}
//     </div>
//     {/* </div> */}

//     {/* RIGHT */}
//     {/* <button
//       onClick={handleNextCard}
//       disabled={currentIndex === priceTemplates.length - 1}
//       className="absolute top-1/2 -translate-y-1/2 z-30 p-2 rounded-full shadow-lg -right-0 bg-blue-700 text-white p-2 rounded-full disabled:opacity-40"
//     >
//       ▶
//     </button> */}
//   </div>
// )}
//     </div>
//   );
// }

//   /* ================= STEP 2 : DEVICE ================= */

//   if (currentStep === 2) {
//   return (
//     <div className="space-y-6">

//       {/* PHONE VERIFICATION (INLINE) */}
//       <PhoneVerifyModal
//         onResult={(success, mobile, customerData) => {

//           if (!success) {
//             // ❌ NOT VERIFIED
//             setIsPhoneVerified(false);

//             updateField("mobile", mobile || "");
//             updateField("name", "");
//             updateField("email", "");
//             updateField("pincode", "");
//             updateField("state", "");
//             updateField("city", "");
//             updateField("location", "");
//             return;
//           }

//           // ✅ VERIFIED
//           setIsPhoneVerified(true);
//           updateField("mobile", mobile);

//           if (customerData) {
//             updateField("name", customerData.name || "");
//             updateField("email", customerData.email || "");
//             updateField("addressLine1", customerData.address1 || "");
//             updateField("addressLine2", customerData.address2 || "");
//             updateField("pincode", customerData.pincode || "");
//             updateField("state", customerData.state || "");
//             updateField("city", customerData.city || "");
//             updateField("location", customerData.location || "");
//           }
//         }}
//       />

//       {!isPhoneVerified && (
//         <p
//           className={cn(
//             "text-xs rounded-xl p-2 border",
//             isRetailerMobile
//               ? "glass-small-card bg-white/10 border-white/30 text-amber-500 font-bold !text-md"
//               : "text-amber-600 bg-amber-50 border-amber-200"
//           )}
//         >
//           Please verify mobile number to add customer details
//         </p>
//       )}

//       {/* -------- CONTACT DETAILS -------- */}
//       <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
//         <Input
//           label="Customer Name"
//           value={form.name}
//           disabled={!isPhoneVerified}
//           onChange={(e) => updateField("name", e.target.value)}
//           error={errors.name}
//           placeholder={"Enter Full Name"}
//         />



//         <Input
//           label="Mobile"
//           value={form.mobile}
//           disabled
//           placeholder={"Auto Filled from verified"}
//         />

//         <Input
//           label="Email"
//           value={form.email}
//           disabled={!isPhoneVerified}
//           onChange={(e) => updateField("email", e.target.value)}
//           error={errors.email}
//           placeholder={"Enter Valid Mail ID"}
//         />

//       </div>

//       {/* -------- LOCATION DETAILS -------- */}
//       <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">

//         {/* ADDRESS LINE 1 (FULL WIDTH) */}
//         <div className="col-span-2 sm:col-span-1">
//           <Input
//             label="Address Line 1"
//             value={form.addressLine1}
//             disabled={!isPhoneVerified}
//             onChange={(e) => updateField("addressLine1", e.target.value)}
//             error={errors.addressLine1}
//             placeholder="House no. / Building Name "
//           />
//         </div>

//         {/* ADDRESS LINE 2 (FULL WIDTH) */}
//         <div className="col-span-2 sm:col-span-1">
//           <Input
//             label="Address Line 2"
//             placeholder="Area / Street / Landmark"
//             value={form.addressLine2}
//             disabled={!isPhoneVerified}
//             onChange={(e) => updateField("addressLine2", e.target.value)}
//             error={errors.addressLine2}
//           />
//         </div>


//         <div className="col-span-2 sm:col-span-1">
//           <Input
//             label="Location"
//             placeholder="Locality / Area"
//             value={form.location}
//             disabled={!isPhoneVerified}
//             onChange={(e) => updateField("location", e.target.value)}
//             error={errors.location}
//           />
//         </div>

//         {/* PINCODE */}
//         <div className="col-span-2 sm:col-span-1">
            
//           <Input
//             label="Pincode"
//             value={form.pincode}
//             disabled={!isPhoneVerified}
//             onChange={(e) => {
//               const value = e.target.value.replace(/\D/g, "");
//               updateField("pincode", value);
//               if (value.length === 6) onPincodeChange(value);
//             }}
//             error={errors.pincode}
//             placeholder="Enter valid 6 digit pincode"
//           />
  
//         </div>

//       {/* STATE */}
//       <div className="col-span-2 sm:col-span-1">
//         <Input label="State" value={form.state} disabled placeholder="Auto Filled from pincode" />
//       </div>
        

//         {/* CITY */}
//         <div className="col-span-2 sm:col-span-1">
//           <Input label="City" value={form.city} disabled placeholder="Auto Filled from pincode"/>
//         </div>
        
//       </div>

//     </div>
//   );
// }

//   /* ================= STEP 3 : CONTACT + LOCATION ================= */
//   if (currentStep === 3) {
//   return (
//   <>
//     <div className="space-y-6">

//       {/* DEVICE INFO */}
//       <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
//         <Input label="Device Brand" value={form.brandName} disabled />
//         <Input label="Device Model" value={form.deviceModel} disabled />
//         <Input label="MOP (₹)" value={form.mopPrice} disabled />

//         <Input
//           label="IMEI 1"
//           value={form.deviceImei}
//           onChange={(e) => {
//             const onlyDigits = e.target.value.replace(/\D/g, "");

//             // 🔒 limit to 16 digits
//             if (onlyDigits.length > 15) return;

//             updateField("deviceImei", onlyDigits);
//           }}
//           error={errors.deviceImei}
//           // rightIcon={
//           //   <button
//           //     type="button"
//           //     onClick={() => {
//           //       setScanTarget("deviceImei");
//           //       setShowScanner(true);
//           //     }}
//           //     className="text-blue-600 hover:text-blue-700"
//           //     title="Scan IMEI 1"
//           //   >
//           //     <ScanLine size={16} />
//           //   </button>
//           // }
//         />



//         {/* OPTIONAL IMAGE UPLOAD */}
//         {/* <div className="text-xs text-slate-500">
//           Or upload barcode image:
//           <input
//             type="file"
//             accept="image/*"
//             className="block mt-1"
//             onChange={async (e) => {
//               const file = e.target.files[0];
//               if (!file) return;

//               try {
//                 const imei = await scanImeiFromImage(file);
//                 updateField("deviceImei", imei);
//                 toast.success("IMEI detected from image");
//               } catch {
//                 toast.error(
//                   "Could not read IMEI from image. Please use camera scan or enter manually."
//                 );
//               }
//             }}
//           />
//         </div> */}

//         <Input
//           label="IMEI 2"
//           value={form.deviceImei2}
//           onChange={(e) =>{
//             const onlyDigits = e.target.value.replace(/\D/g, "");

//             // 🔒 limit to 16 digits
//             if (onlyDigits.length > 15) return;

//             updateField("deviceImei2", onlyDigits);
//           }
            
            
//           }
//           // rightIcon={
//           //   <button
//           //     type="button"
//           //     onClick={() => {
//           //       setScanTarget("deviceImei2");
//           //       setShowScanner(true);
//           //     }}
//           //     className="text-blue-600 hover:text-blue-700"
//           //     title="Scan IMEI 2"
//           //   >
//           //     <ScanLine size={16} />
//           //   </button>
//           // }
//         />

//         {/* <input
//           type="file"
//           accept="image/*"
//           className="text-xs"
//           onChange={async (e) => {
//             const file = e.target.files[0];
//             if (!file) return;

//             try {
//                 const imei = await decodeBarcodeFromImage(file);
//                 updateField("deviceImei", imei);
//                 toast.success("IMEI scanned successfully");
//               } catch (err) {
//                 toast.error(
//                   "Unable to detect IMEI. Please upload a clearer image or scan using camera."
//                 );
//               }
//           }}
//         /> */}

//         <Input
//           label="Serial Number"
//           value={form.serialNumber}
//           onChange={(e) => {
//             const value = e.target.value
//               .replace(/[^a-zA-Z0-9]/g, "") // allow only alphanumeric
//               .toUpperCase();              // optional: normalize

//             if (value.length > 16) return;

//             updateField("serialNumber", value);
//           }}
//           error={errors.serialNumber}
//         />

//       </div>

//       {/* IMAGE UPLOADS */}
//       <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">

//         <ImageUpload
//           label="Bill Photo"
//           value={form.billPhoto}
//           required
//           error={errors.billPhoto}
//           onChange={(file) =>
//             handleImageUpload("billPhoto", file, "bill_photo")
//           }
//         />

//         <ImageUpload
//           label="Device Photo"
//           value={form.devicePhoto}
//           // required
//           error={errors.devicePhoto}
//           onChange={(file) =>
//             handleImageUpload("devicePhoto", file, "device_photo")
//           }
//         />

//         {/* <ImageUpload
//           label="Customer Photo"
//           value={form.customerPhoto}
//           required
//           error={errors.customerPhoto}
//           onChange={(file) =>
//             handleImageUpload("customerPhoto", file, "customer_photo")
//           }
//         /> */}

//       </div>
//     </div>
    
//       {showScanner && (
//         <ImeiScanner
//           onScan={(imei) => {
//             updateField(scanTarget, imei);

//             if (scanTarget === "deviceImei" && !form.deviceImei2) {
//               updateField("deviceImei2", imei);
//             }

//             // ✅ ONLY CLOSE MODAL
//             setShowScanner(false);
//           }}
//           onClose={() => setShowScanner(false)}
//         />
//       )}

// </>
//   );
// }

//   /* ================= STEP 4 : PAYMENT ================= */
//   if (currentStep === 4) {

//   return (
//     <div className="w-full">
//       {/* TOP BAR */}
//       {/* <div className="rounded-2xl border border-slate-200 bg-white shadow-lg"> */}
//         <div className="p-2 sm:p-3">
//           <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
//             <div>
//               <h2 className="text-lg sm:text-xl font-semibold text-slate-900">
//                 Confirm Warranty Registry
//               </h2>
//               <p className="mt-1 text-xs sm:text-sm text-slate-500">
//                 Review details and confirm to activate warranty.
//               </p>
//             </div>

//             <div className="flex items-center gap-2">
//               {/* <Pill tone="amber">Pay Later</Pill> */}
//               <Pill tone="indigo">Step 4 of 4</Pill>
//             </div>
//           </div>

//           {/* BANNER */}
//           <div
//             className={cn(
//               "mt-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between rounded-2xl p-4 transition-all duration-300",
//               isRetailerMobile
//                 ? "glass-small-card bg-white/10 backdrop-blur-2xl border border-white/20 !text-left"
//                 : "border border-indigo-200 bg-gradient-to-r from-indigo-50 to-white shadow-lg"
//             )}
//           >
//             <div className="flex items-center gap-3">
//               <div
//                 className={cn(
//                   "h-10 w-10 rounded-2xl grid place-items-center shadow-lg",
//                   isRetailerMobile
//                     ? "bg-white/20 text-white backdrop-blur-md border border-white/30"
//                     : "bg-indigo-600 text-white"
//                 )}
//               >
//                 🛡️
//               </div>

//               <div>
//                 <p
//                   className={cn(
//                     "text-sm font-semibold",
//                     isRetailerMobile ? "text-black" : "text-indigo-900"
//                   )}
//                 >
//                   Warranty Order Confirmation
//                 </p>

//                 <p
//                   className={cn(
//                     "text-xs",
//                     isRetailerMobile ? "text-black/70" : "text-indigo-700"
//                   )}
//                 >
//                   Verify customer, device & plan before submission.
//                 </p>
//               </div>
//             </div>

//             <div className="flex flex-wrap gap-2">
//               <Pill tone={isRetailerMobile ? "glass" : "emerald"}>
//                 Instant Activation
//               </Pill>

//               <Pill tone={isRetailerMobile ? "glass" : "slate"}>
//                 IMEI Linked
//               </Pill>
//             </div>
//           </div>
//         </div>

//         {/* CONTENT */}
//         <div
//           className={cn(
//             "p-2 sm:p-3 border-t",
//             isRetailerMobile
//               ? "border-white/20 bg-white/5 backdrop-blur-md"
//               : "border-slate-200 bg-slate-50/40"
//           )}
//         >
//           <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
//             {/* LEFT */}
//             <div className="lg:col-span-12 space-y-6">
//               {/* CUSTOMER */}
//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
//                 <div className={cn(
//                     "rounded-2xl shadow-lg",
//                     isRetailerMobile
//                       ? "glass-small-card bg-white/10 border border-white/20 backdrop-blur-xl"
//                       : "border border-slate-200 bg-white"
//                   )}>
//                 <div className="p-2 sm:p-5">
//                   <div className="flex items-center justify-between">
//                     <h4
//                       className={cn(
//                         "text-sm font-semibold",
//                         isRetailerMobile ? "text-black" : "text-slate-900"
//                       )}
//                     >
//                       Customer Information
//                     </h4>
//                     <Pill tone="slate">Customer</Pill>
//                   </div>

//                   <div className="mt-4 space-y-2">
//                     <SummaryRow label="Customer Name" value={form?.name} />
//                     <SummaryRow label="Mobile Number" value={form?.mobile} />
//                     <SummaryRow label="Location" value={form?.location} />
//                   </div>
//                 </div>
//               </div>

//               {/* DEVICE */}
//               <div className={cn(
//                 "rounded-2xl shadow-lg",
//                 isRetailerMobile
//                   ? "glass-small-card bg-white/10 border border-white/20 backdrop-blur-xl"
//                   : "border border-slate-200 bg-white"
//               )}>
//                 <div className="p-2 sm:p-5">
//                   <div className="flex items-center justify-between">
//                     <h4 className="text-sm font-semibold text-slate-900">
//                       Device Information
//                     </h4>
//                     <Pill tone="slate">Device</Pill>
//                   </div>

//                   <div className="mt-4 space-y-2">
//                     <SummaryRow label="Brand" value={form?.brandName} />
//                     <SummaryRow label="Model" value={form?.deviceModel} />
//                     <SummaryRow
//                       label="Device Price (MOP)"
//                       value={
//                         form?.mopPrice !== undefined ? `₹${form?.mopPrice}` : "-"
//                       }
//                       bold
//                     />
//                     <SummaryRow label="IMEI 1" value={form?.deviceImei} />
//                     {form?.deviceImei2 ? (
//                       <SummaryRow label="IMEI 2" value={form?.deviceImei2} />
//                     ) : null}
//                   </div>
//                 </div>
//               </div>
//               </div>

//               {/* PLAN */}
//               <div className={cn(
//                 "rounded-2xl shadow-lg overflow-hidden",
//                 isRetailerMobile
//                   ? "glass-small-card bg-white/10 border border-white/20 backdrop-blur-xl !text-left"
//                   : "border border-indigo-200 bg-white"
//               )}>
//                 <div className={cn(
//                     "p-4 sm:p-5",
//                     isRetailerMobile
//                       ? "bg-white/40 backdrop-blur-xl border border-white/10"
//                       : "bg-gradient-to-r from-indigo-50 to-white"
//                   )}>
//                   <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
//                     <div>
//                       <Pill tone="indigo">Warranty Plan</Pill>
//                       <h4 className="mt-2 text-sm font-semibold text-slate-900">
//                         Plan Details
//                       </h4>
//                       <p className="text-xs text-slate-500 mt-1">
//                         Make sure plan & expiry are correct.
//                       </p>
//                     </div>

//                     <div className="flex gap-2 flex-wrap">
//                       <Pill tone="emerald">
//                         Claims: {product?.claims ?? "-"}
//                       </Pill>
//                       <Pill tone="slate">Expiry: {form?.expiryDate || "-"}</Pill>
//                     </div>
//                   </div>

//                   <div className="mt-4 space-y-2">
//                     <SummaryRow label="Plan Name" value={product?.name} />
//                     {/* <SummaryRow
//                       label="Warranty Price"
//                       value={
//                         selectedTemplate?.product_price !== undefined
//                           ? `₹${selectedTemplate?.product_price}`
//                           : "-"
//                       }
//                       bold
//                     /> */}
//                   </div>
//                 </div>

//                 {/* FEATURES */}
//                 <div className="grid grid-cols-1 sm:grid-cols-3">
//                   <div className="p-4 sm:p-5 border-t border-slate-200">
//                     <p className="text-xs font-semibold text-slate-700 mb-3">
//                       Plan Features
//                     </p>

//                     {features.length ? (
//                       <>
//                         <div className="flex flex-wrap gap-2">
//                           {(expanded.features ? features : features.slice(0, 4)).map((f, i) => (
//                             <span
//                               key={i}
//                               className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-3 py-1 text-xs font-medium text-slate-700 ring-1 ring-slate-200"
//                             >
//                               {f}
//                             </span>
//                           ))}
//                         </div>

//                         {features.length > 4 && (
//                           <button
//                             onClick={() =>
//                               setExpanded((prev) => ({
//                                 ...prev,
//                                 features: !prev.features,
//                               }))
//                             }
//                             className="mt-3 text-xs font-semibold text-blue-600 hover:underline"
//                           >
//                             {expanded.features ? "View Less" : "View More"}
//                           </button>
//                         )}
//                       </>
//                     ) : (
//                       <p className="text-xs text-slate-400 italic">
//                         No features available
//                       </p>
//                     )}
//                   </div>

//                 <div className="p-4 sm:p-5 border-t border-slate-200">
//                   <p className="text-xs font-semibold text-slate-700 mb-3">
//                     Coverage
//                   </p>

//                   {coverage?.length ? (
//                     <>
//                       <div className="flex flex-wrap gap-2">
//                         {(expanded.coverage ? coverage : coverage.slice(0, 4)).map((c, i) => (
//                           <span
//                             key={i}
//                             className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-3 py-1 text-xs font-medium text-emerald-700 ring-1 ring-emerald-200"
//                           >
//                             <span className="text-emerald-600">✔</span>
//                             {c}
//                           </span>
//                         ))}
//                       </div>

//                       {coverage.length > 4 && (
//                         <button
//                           onClick={() =>
//                             setExpanded((prev) => ({
//                               ...prev,
//                               coverage: !prev.coverage,
//                             }))
//                           }
//                           className="mt-3 text-xs font-semibold text-blue-600 hover:underline"
//                         >
//                           {expanded.coverage ? "View Less" : "View More"}
//                         </button>
//                       )}
//                     </>
//                   ) : (
//                     <p className="text-xs text-slate-400 italic">
//                       No coverage details available
//                     </p>
//                   )}
//                 </div>

//                 <div className="p-4 sm:p-5 border-t border-slate-200">
//                   <p className="text-xs font-semibold text-slate-700 mb-3">
//                     Exclusions
//                   </p>

//                   {exclusions?.length ? (
//                     <>
//                       <div className="flex flex-wrap gap-2">
//                         {(expanded.exclusions ? exclusions : exclusions.slice(0, 4)).map((e, i) => (
//                           <span
//                             key={i}
//                             className="inline-flex items-center gap-1 rounded-full bg-blue-50 px-3 py-1 text-xs font-medium text-blue-700 ring-1 ring-blue-200"
//                           >
//                             <span className="text-blue-600">✔</span>
//                             {e}
//                           </span>
//                         ))}
//                       </div>

//                       {exclusions.length > 4 && (
//                         <button
//                           onClick={() =>
//                             setExpanded((prev) => ({
//                               ...prev,
//                               exclusions: !prev.exclusions,
//                             }))
//                           }
//                           className="mt-3 text-xs font-semibold text-blue-600 hover:underline"
//                         >
//                           {expanded.exclusions ? "View Less" : "View More"}
//                         </button>
//                       )}
//                     </>
//                   ) : (
//                     <p className="text-xs text-slate-400 italic">
//                       No exclusions specified
//                     </p>
//                   )}
//                 </div>
//                 </div>

//               </div>

//               {/* ACTIVATION SUMMARY */}
              
//             </div>            
//           </div>

//           <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 mt-3">
//             <div className="lg:col-span-4">
//                 <div className="lg:sticky lg:top-4 ">
//                 <div className={cn(
//                   "rounded-2xl shadow-lg",
//                   isRetailerMobile
//                     ? "glass-small-card bg-white/10 border border-white/20 backdrop-blur-xl"
//                     : "border border-slate-200 bg-white"
//                 )}>
//                   <div className="p-4 sm:p-5">
//                     <div className="flex items-center justify-between mb-3">
//                       <h4 className="text-sm font-semibold text-slate-900">
//                         Settlement Summary
//                       </h4>
//                       <div
//                           onClick={() => setShowSettlement((prev) => !prev)}
//                           className="cursor-pointer"
//                         >
//                           <Pill tone="amber">
//                             Retailer Due {showSettlement ? "▲" : "▼"}
//                           </Pill>
//                         </div>
//                     </div>

//                     <SummaryRow
//                         label="Product Price"
//                         value={`₹${productPrice}`}
//                         bold
//                       />

//                     {showSettlement && (
//                     <div className="mt-4 space-y-3 animate-fadeIn">
//                       {/* <SummaryRow
//                         label="Employee Payout"
//                         value={`₹${employeePayout}`}
//                       /> */}
//                       <SummaryRow
//                         label="Retailer Payout"
//                         value={`₹${retailerPayout}`}
//                       />

//                       <div
//                         className={cn(
//                           "my-3 h-px",
//                           isRetailerMobile ? "bg-slate-400" : "bg-slate-200"
//                         )}
//                       />
//                       <SummaryRow
//                         label="Total Payout"
//                         value={`₹${TotalPayout}`}
//                       />

//                       <div
//                         className={cn(
//                           "my-3 h-px",
//                           isRetailerMobile ? "bg-slate-400" : "bg-slate-200"
//                         )}
//                       />

//                       <div className={cn(
//                           "mt-3 rounded-2xl p-4",
//                           isRetailerMobile
//                             ? "bg-white/10 border border-white/20 backdrop-blur-md"
//                             : "border border-amber-200 bg-amber-50"
//                         )}>
//                         <p className="text-[11px] text-amber-800/80">
//                           Amount to be collected from retailer
//                         </p>
//                         <p className="mt-1 text-xl font-bold text-amber-900">
//                           ₹{retailerPending}
//                         </p>
//                         {payLaterSelected && (
//                         <p className="mt-1 text-[11px] text-amber-800/80">
//                           Payment will be collected later.
//                         </p>
//                         )}
//                       </div>
//                     </div>
//                     )}

//                     {loadingPaymentConfig && (
//                       <div className="mt-4 rounded-xl border border-slate-200 bg-slate-50 p-4 text-xs text-slate-500">
//                         Loading payment options…
//                       </div>
//                     )}

//                     {/* PAYMENT ACTION */}
//                     {!loadingPaymentConfig && !paymentSuccess &&
//                     (paymentButtons.showPayNow || paymentButtons.showPayLater) && (

//                       <div
//                         className={cn(
//                           "mt-4 rounded-2xl p-4",
//                           isRetailerMobile
//                             ? "glass-small-card bg-white/10 backdrop-blur-xl border border-white/20"
//                             : "border border-slate-200 bg-slate-50"
//                         )}
//                       >
//                         <p
//                           className={cn(
//                             "text-xs font-semibold mb-3",
//                             isRetailerMobile ? "text-black/80" : "text-slate-600"
//                           )}
//                         >
//                           Choose payment method
//                         </p>

//                         {/* BUTTON ROW */}
//                         <div className="space-y-4">

//                             {/* WALLET CARD */}
//                             {!payLaterSelected && !hideWalletForRetailerUser && (
//                             <div
//                               className={cn(
//                                 "relative rounded-2xl border p-3 transition-all duration-300",
//                                 walletDisabled
//                                   ? "bg-slate-100 border-slate-200 opacity-60 cursor-not-allowed pointer-events-none"
//                                   : "bg-gradient-to-r from-emerald-50 to-emerald-100 border-emerald-200 hover:shadow-md"
//                               )}
//                             >
//                               {/* TOP ROW */}
//                               <div className="flex items-start justify-between">

//                                 <div className="flex items-start gap-2">

//                                   {/* Checkbox */}
//                                   <input
//                                     type="checkbox"
//                                     disabled={walletDisabled || walletLoading}
//                                     checked={useWallet}
//                                     onChange={(e) => setUseWallet(e.target.checked)}
//                                     className="mt-1 h-4 w-4 rounded border-slate-300 text-emerald-600"
//                                   />

//                                   {/* Icon */}
//                                   <div
//                                     className={cn(
//                                       "flex items-center justify-center w-10 h-10 rounded-xl",
//                                       walletDisabled
//                                         ? "bg-slate-200 text-slate-400"
//                                         : "bg-white text-emerald-600 shadow-sm"
//                                     )}
//                                   >
//                                     <Wallet size={18} />
//                                   </div>

//                                   {/* Text */}
//                                   <div>
//                                     <p
//                                       className={cn(
//                                         "font-semibold text-sm",
//                                         walletDisabled ? "text-slate-400" : "text-slate-800"
//                                       )}
//                                     >
//                                       Wallet Balance
//                                     </p>

//                                     {!walletDisabled && (
//                                       <p className="text-xs text-slate-500">
//                                         Use wallet to pay instantly
//                                       </p>
//                                     )}
//                                   </div>
//                                 </div>

//                                 {/* BALANCE */}
//                                 {!walletLoading && (
//                                   <div
//                                     className={cn(
//                                       "px-3 py-1 rounded-lg font-bold",
//                                       walletDisabled
//                                         ? "bg-slate-200 text-slate-400 text-sm"
//                                         : "bg-white text-emerald-700 shadow-sm text-sm"
//                                     )}
//                                   >
//                                     ₹{walletBalance}
//                                   </div>
//                                 )}
//                               </div>

//                               {/* WARNING */}
//                               {!walletLoading && walletDisabled && (
//                                 <div className="flex items-center gap-2 mt-3 text-sm text-red-600 text-bold">
//                                   <AlertTriangle size={14} />
//                                   Insufficient wallet balance
//                                 </div>
//                               )}
//                             </div>
//                           )}

//                             {/* PAYMENT BUTTONS */}
//                             <div className="flex gap-3">

//                               {/* PAY NOW */}
//                               {paymentButtons.showPayNow && !payLaterSelected && (
//                                 <button
//                                   type="button"
//                                   onClick={() =>
//                                     setConfirmModal({
//                                       open: true,
//                                       type: useWallet ? "wallet" : "paynow",
//                                     })
//                                   }
//                                   disabled={paymentSaving}
//                                   className={cn(
//                                     "flex-1 rounded-xl px-4 py-2.5 text-sm font-semibold shadow-sm transition flex items-center justify-center gap-2",
//                                     paymentSaving
//                                       ? "bg-slate-400 cursor-not-allowed text-white"
//                                       : isRetailerMobile
//                                       ? "bg-emerald-500/80 backdrop-blur text-white border border-white/30"
//                                       : "bg-emerald-600 text-white hover:bg-emerald-700"
//                                   )}
//                                 >
//                                   {paymentSaving ? (
//                                     <>
//                                       <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
//                                       Processing..
//                                     </>
//                                   ) : (
//                                     "Pay Now"
//                                   )}
//                                 </button>
//                               )}

//                               {/* PAY LATER */}
//                               {paymentButtons.showPayLater && (
//                                 <button
//                                   type="button"
//                                   onClick={() =>
//                                     setConfirmModal({
//                                       open: true,
//                                       type: "paylater",
//                                     })
//                                   }
//                                   className={cn(
//                                     "flex-1 rounded-xl px-4 py-2.5 text-sm font-semibold transition border",
//                                     payLaterSelected
//                                       ? isRetailerMobile
//                                         ? "glass-small-card bg-white/25 text-black border-white/40"
//                                         : "border-amber-400 bg-amber-100 text-amber-900"
//                                       : isRetailerMobile
//                                         ? " bg-white/10 text-black border-white/30 hover:bg-white/20"
//                                         : "border-amber-300 bg-amber-50 text-amber-800 hover:bg-amber-100"
//                                   )}
//                                 >
//                                   {payLaterSelected ? "✓ Pay Later Selected" : "Pay Later"}
//                                 </button>
//                               )}
//                             </div>

//                           </div>

                        

//                         {/* ADMIN NOTE */}
//                         {(paymentConfig.admin_paylater_status === 1 ||
//                           paymentConfig.admin_paynow_status === 1) && (
//                           <p
//                             className={cn(
//                               "mt-3 text-[11px] font-medium text-center",
//                               isRetailerMobile ? "text-black/60" : "text-slate-500"
//                             )}
//                           >
//                             Payment options enforced by company policy.
//                           </p>
//                         )}
//                       </div>
//                     )}

//                     {paymentSuccess && (
//                       <div className={cn(
//                           "mt-4 rounded-2xl p-4 text-center",
//                           isRetailerMobile
//                             ? "bg-white/10 border border-white/20 backdrop-blur-md text-white"
//                             : "border border-emerald-300 bg-emerald-50"
//                         )}>
//                         <div className="flex flex-col items-center gap-2">
//                           <div className="h-10 w-10 rounded-full bg-emerald-600 text-white flex items-center justify-center text-lg">
//                             ✓
//                           </div>

//                           <p className="text-sm font-semibold text-emerald-900">
//                             Payment Successful
//                           </p>

//                           <p className="text-xs text-emerald-700">
//                             Proceed to activate warranty
//                           </p>

//                           {/* <button
//                             type="button"
//                             onClick={() => {
//                               // 🔥 FINAL WARRANTY ACTIVATION API
//                               // call activateWarranty()
//                               toast.success("Warranty activated successfully");
//                             }}
//                             className="mt-3 w-full rounded-xl bg-emerald-600 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-700 transition"
//                           >
//                             Proceed to Register Warranty
//                           </button> */}
//                         </div>
//                       </div>
//                     )}

//                     {payLaterSelected && (
//                       <div className="mt-3 rounded-lg bg-amber-50 border border-amber-200 px-3 py-2 text-xs text-amber-800">
//                         Payment mode: <b>Pay Later</b>. Warranty will be activated now and payment
//                         collected later.
//                       </div>
//                     )}
//                     {/* CONFIRM CHECK */}
                    


//                   </div>
//                 </div>

//               </div>
//               </div>

//                 <div className="lg:col-span-8">
//                 <div className="rounded-2xl border border-emerald-200 bg-emerald-50 shadow-lg">
//                 <div className="p-4 sm:p-5">
//                   <div className="flex items-center justify-between">
//                     <h4 className="text-sm font-semibold text-emerald-900">
//                       Activation Summary
//                     </h4>
//                     <Pill tone="emerald">Ready</Pill>
//                   </div>

//                   <ul className="mt-4 space-y-2 text-xs sm:text-sm text-emerald-900">
//                     <li className="flex gap-2">
//                       <span>✔</span> Warranty activates instantly after confirm
//                     </li>
//                     <li className="flex gap-2">
//                       <span>✔</span> Linked to IMEI for validation
//                     </li>
//                     <li className="flex gap-2">
//                       <span>✔</span> Customer receives SMS confirmation
//                     </li>
//                     <li className="flex gap-2">
//                       <span>✔</span> Valid until{" "}
//                       <b className="font-semibold">{form?.expiryDate || "-"}</b>
//                     </li>
//                   </ul>
//                 </div>
//               </div>

//               <label
//                       className={`mt-4 flex items-start gap-3 rounded-xl border p-3 cursor-pointer
//                         ${
//                           payLaterSelected || paymentSuccess
//                             ? "border-slate-200 bg-slate-50"
//                             : "border-slate-200 bg-slate-100 opacity-60 cursor-not-allowed"
//                         }
//                       `}
//                     >
//                       <input
//                         type="checkbox"
//                         disabled={!payLaterSelected && !paymentSuccess}
//                         className="mt-1 h-4 w-4 rounded border-slate-300 text-indigo-600 focus:ring-indigo-600"
//                         checked={confirmed}
//                         onChange={(e) => setConfirmed(e.target.checked)}
//                       />

//                       <span className="text-xs text-slate-800 leading-5">
//                         I confirm that all device details, IMEI numbers and warranty plan information
//                         are correct.
//                       </span>
//                     </label>
//               </div>
              
//             </div>

//           {/* MOBILE BOTTOM BAR (optional feel) */}
//           {!paymentSuccess && (
//             <div
//             className={cn(
//               "mt-6 lg:hidden rounded-2xl p-4 shadow-lg",
//               isRetailerMobile
//                 ? "glass-small-card bg-white/10 backdrop-blur-xl border border-white/20"
//                 : "border border-slate-200 bg-white"
//             )}
//           >
//             <div className="flex items-center justify-between">
//               <p
//                 className={cn(
//                   "text-xs",
//                   isRetailerMobile ? "text-black/70" : "text-slate-500"
//                 )}
//               >
//                 Retailer Pending
//               </p>

//               <p
//                 className={cn(
//                   "text-sm font-semibold",
//                   isRetailerMobile ? "text-black" : "text-slate-900"
//                 )}
//               >
//                 ₹{retailerPending}
//               </p>
//             </div>
//           </div>
//           )}
//         </div>
//       {/* </div> */}

//       <ConfirmSheet
//         open={confirmModal.open}
//         type={confirmModal.type}
//         title="Confirm Action"
//         message={
//           confirmModal.type === "wallet"
//             ? "Pay using wallet balance?"
//             : confirmModal.type === "paynow"
//             ? "Proceed to payment?"
//             : "Activate warranty and pay later?"
//         }
//         confirmText="Yes"
//         cancelText="Cancel"
//         onCancel={() => setConfirmModal({ open: false, type: null })}
//         onConfirm={() => {
//           if (confirmModal.type === "wallet" || confirmModal.type === "paynow") {
//             handlePayNow();
//           }

//           if (confirmModal.type === "paylater") {
//             setPayLaterSelected(true);
//             setIsPayLater(1);
//             setConfirmed(false);
//             toast.success("Pay Later selected");
//           }

//           setConfirmModal({ open: false, type: null });
//         }}
//       />

//       {/* LOADER OVERLAY */}
//       {/* {paymentSaving && (
//         <div
//           className={cn(
//             "fixed inset-0 z-50 flex flex-col items-center justify-center backdrop-blur",
//             isRetailerMobile
//               ? "bg-black/40"
//               : "bg-white/70"
//           )}
//         >
//           <RegularLoader />
//           <p
//             className={cn(
//               "mt-3 text-sm",
//               isRetailerMobile ? "text-white" : "text-slate-600"
//             )}
//           >
//             Processing payment…
//           </p>
//         </div>
//       )} */}
//     </div>
//   );
// }

//   return null;
// };


// function SummaryRow({ label, value, bold = false }) {
//   return (
//     <div className="flex items-start justify-between gap-4">
//       <p className="text-xs sm:text-sm text-slate-500">{label}</p>
//       <p
//         className={[
//           "text-xs sm:text-sm text-slate-900 text-right break-words",
//           bold ? "font-semibold" : "font-medium",
//         ].join(" ")}
//       >
//         {value || "-"}
//       </p>
//     </div>
//   );
// }

// function Pill({ children, tone = "slate" }) {
//   const tones = {
//     slate: "bg-slate-100 text-slate-700 ring-slate-200",
//     indigo: "bg-indigo-100 text-indigo-700 ring-indigo-200",
//     emerald: "bg-emerald-100 text-emerald-700 ring-emerald-200",
//     amber: "bg-amber-100 text-amber-800 ring-amber-200",
//   };
//   return (
//     <span
//       className={`inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-semibold ring-1 ${tones[tone]}`}
//     >
//       {children}
//     </span>
//   );
// }

// function ConfirmSheet({
//   open,
//   title,
//   message,
//   type,
//   confirmText = "Yes",
//   cancelText = "Cancel",
//   onConfirm,
//   onCancel,
// }) {
//   if (!open) return null;

//   const isMobile = window.innerWidth < 640;

//   const iconMap = {
//     wallet: {
//       icon: "💰",
//       desc: "Amount will be deducted from your wallet balance.",
//       color: "text-emerald-400",
//     },
//     paynow: {
//       icon: "💳",
//       desc: "You will be redirected to secure payment.",
//       color: "text-blue-400",
//     },
//     paylater: {
//       icon: "⏳",
//       desc: "Warranty will provisioned and payment can be collected later.",
//       color: "text-amber-400",
//     },
//   };

//   const info = iconMap[type] || {};

//   return createPortal(
//     <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-sm">

//       {isMobile ? (
//         <div className="absolute bottom-0 w-full max-w-md rounded-t-3xl glass-small-card bg-white/10 backdrop-blur-2xl border border-white/20 p-6 min-h-[260px] animate-slideUp">

//           {/* HANDLE */}
//           <div className="w-12 h-1.5 bg-white/40 rounded-full mx-auto mb-4" />

//           {/* ICON */}
//           <div className="flex justify-center mb-3">
//             <div className="text-3xl">{info.icon}</div>
//           </div>

//           <h3 className="text-lg font-semibold text-center text-slate-200">
//             {title}
//           </h3>

//           <p className="mt-2 text-sm text-center text-slate-300">
//             {message}
//           </p>

//           {info.desc && (
//             <p className={`mt-2 text-xs text-center ${info.color}`}>
//               {info.desc}
//             </p>
//           )}

//           <div className="mt-6 flex gap-3">
//             <button
//               onClick={onCancel}
//               className="flex-1 rounded-xl border border-white/30 bg-white/10 backdrop-blur-md py-2.5 text-sm font-medium text-black"
//             >
//               {cancelText}
//             </button>

//             <button
//               onClick={onConfirm}
//               className="flex-1 rounded-xl bg-blue-600/90 backdrop-blur text-white py-2.5 text-sm font-semibold shadow-lg"
//             >
//               {confirmText}
//             </button>
//           </div>
//         </div>
//       ) : (
//         <div className="w-full max-w-sm rounded-2xl bg-white shadow-2xl p-6 animate-fadeIn">

//           {/* ICON */}
//           <div className="text-3xl mb-3 text-center">{info.icon}</div>

//           <h3 className="text-lg font-semibold text-slate-900 text-center">
//             {title}
//           </h3>

//           <p className="mt-2 text-sm text-slate-600 text-center">
//             {message}
//           </p>

//           {info.desc && (
//             <p className={`mt-2 text-xs text-center ${info.color}`}>
//               {info.desc}
//             </p>
//           )}

//           <div className="mt-6 flex justify-end gap-3">
//             <button
//               onClick={onCancel}
//               className="px-4 py-2 rounded-lg border border-slate-300 text-sm font-medium"
//             >
//               {cancelText}
//             </button>

//             <button
//               onClick={onConfirm}
//               className="px-4 py-2 rounded-lg bg-blue-600 text-white text-sm font-semibold"
//             >
//               {confirmText}
//             </button>
//           </div>
//         </div>
//       )}

//     </div>,
//     document.body
//   );
// }


// {priceTemplates.length > 0 && (
//   <div className="md:hidden relative flex items-center justify-center">

//     {/* LEFT */}
//     <button
//       onClick={handlePrevCard}
//       disabled={currentIndex === 0}
//       className={cn(
//         "absolute -left-4 z-20 p-2 rounded-full transition-all",
//         isRetailerMobile
//           ? "bg-white/80 backdrop-blur-md border border-white/60 text-black"
//           : "bg-blue-700 text-white",
//         "disabled:opacity-50"
//       )}
//     >
//       ◀
//     </button>

//     {/* CARD */}
//     {/* <div className="w-full max-w-sm overflow-hidden relative"> */}
//     <div
//       key={currentIndex}
//       className={`transition-all duration-500 ease-in-out
//         ${
//           direction === 1
//             ? "animate-slide-left"
//             : direction === -1
//             ? "animate-slide-right"
//             : ""
//         }
//       `}
//     >

//       {(() => {
//         const tpl = priceTemplates[currentIndex];
//         const product = tpl.warranty_product;

//         const isPercent = Number(product?.is_percent) === 1;
//         const mopPrice = Number(form?.mopPrice || 0);

//         const effectiveMrp = isPercent
//           ? Math.round((Number(product?.mrp || 0) / 100) * mopPrice)
//           : Number(product?.mrp || 0);

//         const effectiveMargin = isPercent
//           ? Math.round((Number(tpl?.retailer_payout || 0) / 100) * mopPrice)
//           : Number(tpl?.retailer_payout || 0);

//         return (
//           <div
//             key={tpl.id}
//             onClick={() => {
//               setSelectedTemplate(tpl);

//               const expiryDate = new Date();
//               expiryDate.setDate(
//                 expiryDate.getDate() +
//                   Number(tpl.warranty_product?.validity || 0)
//               );

//               updateField(
//                 "expiryDate",
//                 expiryDate.toISOString().split("T")[0]
//               );
//             }}
//             className={cn(
//               "relative cursor-pointer overflow-hidden rounded-3xl transition-all duration-300",
//               isRetailerMobile
//                 ? selectedTemplate?.id === tpl.id
//                   ? "glass-small-card border-white/40 bg-white/20 shadow-2xl scale-[1.03] ring-2 ring-white/40"
//                   : "glass-small-card border-white/30 bg-white/10"
//                 : selectedTemplate?.id === tpl.id
//                   ? "border-blue-600 bg-blue-50 shadow-2xl scale-[1.03] ring-2 ring-blue-300"
//                   : "border-slate-200 bg-white hover:shadow-lg"
//             )}
//           >

//             {/* SELECTED BADGE */}
//             {selectedTemplate?.id === tpl.id && (
//               <div className="absolute top-5 left-5 z-30 bg-white text-blue-600 rounded-full px-3 py-1 text-[10px] font-semibold shadow-lg animate-pulse">
//                 ✓ Selected
//               </div>
//             )}
//             {/* INFO ICON */}
//             <div
//               onClick={(e) => {
//                 e.stopPropagation();
//                 setOpenInfoId(openInfoId === tpl.id ? null : tpl.id);
//               }}
//               className={cn(
//                   "absolute top-5 right-5 z-30 h-8 w-8 rounded-full flex items-center justify-center cursor-pointer transition",
//                   isRetailerMobile
//                     ? "bg-white/80 backdrop-blur-md border border-white/30 text-white"
//                     : "bg-white shadow-md border"
//                 )}
//             >
//               <span className="text-blue-600 text-sm font-bold">i</span>
//             </div>

//             {/* PRICE POPUP */}
//             {openInfoId === tpl.id && (
//               <div
//                 onClick={(e) => e.stopPropagation()}
//                 className={cn(
//                   "absolute top-12 right-4 w-60 rounded-2xl p-4 z-40 animate-fadeIn",
//                   isRetailerMobile
//                     ? "bg-white/20 backdrop-blur-xl border border-white/30 text-white"
//                     : "bg-white shadow-xl border border-blue-200"
//                 )}
//               >
//                 <p className="text-xs font-semibold text-slate-600 mb-3 uppercase tracking-wide">
//                   Price Breakdown
//                 </p>

//                 <div className="space-y-2 text-sm">
//                   <div className="flex justify-between">
//                     <span className="text-slate-500">MRP</span>
//                     <span className="font-semibold text-slate-900">
//                       ₹{effectiveMrp}
//                     </span>
//                   </div>

//                   <div className="flex justify-between">
//                     <span className="text-slate-500">Profit</span>
//                     <span className="font-semibold text-blue-600">
//                       ₹{effectiveMargin}
//                     </span>
//                   </div>

//                   <div className="border-t pt-2 flex justify-between">
//                     <span className="text-slate-600 font-medium">Payable</span>
//                     <span className="font-bold text-amber-600">
//                       ₹{effectiveMrp - effectiveMargin}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* TOP GRADIENT */}
//             <div
//               className={`relative h-20 transition-all duration-300 ${
//                 selectedTemplate?.id === tpl.id
//                   ? "bg-gradient-to-br from-blue-700 via-blue-600 to-indigo-700"
//                   : "bg-gradient-to-br from-blue-500 via-sky-400 to-indigo-500"
//               }`}
//             >
//               <svg
//                 className="absolute bottom-0 w-full"
//                 viewBox="0 0 1440 120"
//                 preserveAspectRatio="none"
//               >
//                 <path
//                   fill={isRetailerMobile ? "rgba(255,255,255,0.15)" : "#ffffff"}
//                   d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,42.7C1120,32,1280,32,1360,32L1440,32L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z"
//                 />
//               </svg>
//             </div>

//                 {/* 💲 PRICE BADGE */}
//                 <div className="absolute top-7 left-1/2 -translate-x-1/2 z-10">
//                   <div className="w-20 h-20 rounded-full bg-white shadow-lg border flex items-center justify-center overflow-hidden">
//                     {product?.image ? (
//                       <img
//                         src={product.image}
//                         alt={product.name}
//                         className="w-full h-full object-contain p-2"
//                       />
//                     ) : (
//                       <span className="text-xs text-slate-400">No Image</span>
//                     )}
//                   </div>
//                 </div>

//                 {/* CONTENT */}
//                 <div className="pt-10 px-5 pb-6 text-center">
//                   {/* IMAGE */}
//                   {/* <div className="mx-auto mb-3 w-16 h-16 rounded-xl border bg-white flex items-center justify-center overflow-hidden">
//                     {product?.image ? (
//                       <img
//                         src={product.image}
//                         alt={product.name}
//                         className="w-full h-full object-contain"
//                       />
//                     ) : (
//                       <span className="text-xs text-slate-400">No Image</span>
//                     )}
//                   </div> */}

//                   {/* TITLE */}
//                   <h3 className="text-sm font-bold uppercase tracking-wide text-blue-600">
//                     {product?.name}
//                   </h3>
//                   <p className="text-xs text-slate-500 mt-1">
//                     Valid Upto: {getExpiryDate(product?.validity)}
//                   </p>

//                   {/* INFO */}
//                   <div className="flex justify-center gap-2 items-center py-2 text-sm text-slate-700">
//                     <p>
//                       MRP:{" "}
//                       <span className="font-semibold">
//                         ₹{effectiveMrp}
//                         {/* {isPercent && (
//                           <span className="text-[11px] text-slate-500 ml-1">
//                             ({product?.mrp}% of ₹{form?.mopPrice})
//                           </span>
//                         )} */}
//                       </span>
//                     </p>

//                     <p>
//                       Margin:{" "}
//                       <span className="font-semibold">
//                         ₹{effectiveMargin}
//                         {/* {isPercent && (
//                           <span className="text-[11px] text-slate-500 ml-1">
//                             ({tpl?.retailer_payout}% of ₹{form?.mopPrice})
//                           </span>
//                         )} */}
//                       </span>
//                     </p>
//                   </div>

//                   {/* META */}
//                   <div className="mt-4 grid grid-cols-2 gap-3 text-xs">
//                     <div className="rounded-xl border bg-emerald-50 py-2">
//                       <p className="text-emerald-600 font-semibold">Validite</p>
//                       <p className="font-bold">{product?.validity} days</p>
//                     </div>

//                     <div className="rounded-xl border bg-violet-50 py-2">
//                       <p className="text-violet-600 font-semibold">Upto Claims</p>
//                       <p className="font-bold">{product?.claims}</p>
//                     </div>
//                   </div>

//                   {/* FEATURES */}
//                   <div className="mt-5 text-left">
//                     <p className="text-xs font-semibold text-blue-700 mb-2">
//                       Features
//                     </p>

//                     {product?.features ? (() => {
//                       const features = product.features.split(".").map(f => f.trim()).filter(Boolean);
//                       const isExpanded = expandAll[tpl.id];

//                       const visibleFeatures = isExpanded ? features : features.slice(0, 2);

//                       return (
//                         <>
//                           <ul className="space-y-1">
//                             {visibleFeatures.map((f, i) => (
//                               <li key={i} className="flex gap-2 text-sm text-slate-700">
//                                 {f}
//                               </li>
//                             ))}
//                           </ul>

//                           {features.length > 2 && (
//                             <button
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 setExpandAll(prev => ({
//                                   ...prev,
//                                   [tpl.id]: !prev[tpl.id],
//                                 }));
//                               }}
//                               className="mt-2 text-xs font-semibold text-blue-600 underline"
//                             >
//                               {isExpanded ? "View less" : "View more"}
//                             </button>
//                           )}
//                         </>
//                       );
//                     })() : (
//                       <p className="text-xs text-slate-400 italic">
//                         No features available
//                       </p>
//                     )}
//                   </div>

//                   {/* COVERAGE */}
//                   <div className="mt-4 text-left">
//                     <p className="text-xs font-semibold text-blue-700 mb-2">
//                       Coverage
//                     </p>

//                     {product?.coverage ? (() => {
//                       const coverage = product.coverage.split(".").map(f => f.trim()).filter(Boolean);
//                       const isExpanded = expandedCoverage[tpl.id];

//                       const visibleCoverage = isExpanded ? coverage : coverage.slice(0, 2);

//                       return (
//                         <>
//                           <ul className="space-y-1">
//                             {visibleCoverage.map((f, i) => (
//                               <li key={i} className="flex gap-2 text-sm text-slate-700">
//                                 <span className="text-emerald-500 font-bold">✔</span>
//                                 {f}
//                               </li>
//                             ))}
//                           </ul>

//                           {coverage.length > 2 && (
//                             <button
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 setExpandedCoverage(prev => ({
//                                   ...prev,
//                                   [tpl.id]: !prev[tpl.id],
//                                 }));
//                               }}
//                               className="mt-2 text-xs font-semibold text-blue-600 underline"
//                             >
//                               {isExpanded ? "View less" : "View more"}
//                             </button>
//                           )}
//                         </>
//                       );
//                     })() : (
//                       <p className="text-xs text-slate-400 italic">
//                         No coverage available
//                       </p>
//                     )}
//                   </div>
//                 </div>
//           </div>
//         );
//       })()}
//     </div>
//     {/* </div> */}

//     {/* RIGHT */}
//     <button
//       onClick={handleNextCard}
//       disabled={currentIndex === priceTemplates.length - 1}
//       className="absolute -right-4 z-20 bg-blue-700 text-white p-2 rounded-full disabled:opacity-40"
//     >
//       ▶
//     </button>
//   </div>
// )}




// import RegularLoader from "../../../../Component/Loader/RegularLoader";
// import { Input } from "./Input";

// /* ===============================
//    FORM BODY
// ================================ */
// export const FormBody = ({
//   currentStep,
//   form,
//   errors,
//   updateField,
//   existingCustomer,
//   verifiedMobile,
//   categories = [],
//   priceTemplates = [],
//   selectedTemplate,
//   setSelectedTemplate,
//   loading = false,

//   onViewTemplates, // ✅ NEW
//   onPincodeChange,
//   pinLoading,


// }) => {
  

//   /* ================= STEP 1 : PRICING ================= */
  
//   if (currentStep === 1) {
//     return (
//       <div className="space-y-6">

//         {/* CATEGORY + PRICE */}
//         <div className="grid grid-cols-2 gap-4">
//           <div className="flex flex-col gap-1">
//             <label className="text-sm font-medium text-slate-700">
//               Category
//             </label>

//             <select
//               value={form.category}
//               onChange={(e) => updateField("category", e.target.value)}
//               className="w-64 px-3 py-2 border rounded-lg text-sm bg-white"
//             >
//               <option value="">Select Category</option>
//               {categories.map((cat) => (
//                 <option key={cat.id} value={cat.id}>
//                   {cat.name}
//                 </option>
//               ))}
//             </select>

//             {errors.category && (
//               <p className="text-xs text-red-500">
//                 {errors.category}
//               </p>
//             )}
//           </div>


//           <Input
//             label="MOP Price (₹)"
//             value={form.mopPrice}
//             onChange={(e) => updateField("mopPrice", e.target.value)}
//             error={errors.mopPrice}
//             type="number"
//           />
//         </div>

//         {/* BUTTON */}
//         <button
//           onClick={onViewTemplates}
//           disabled={loading}
//           className="px-6 py-2 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 disabled:opacity-50"
//         >
//           {loading ? "Loading..." : "View Templates"}
//         </button>

//         {/* TEMPLATES */}
//         {loading ? (
//           <RegularLoader />
//         ) : priceTemplates.length > 0 ? (
//           <div>
//             <h3 className="text-sm font-semibold mb-3">
//               Select Price Template
//             </h3>

//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
//               {priceTemplates.map((tpl) => {
//                 const product = tpl.warranty_product;
//                 const category = product?.categories?.[0]?.name;

//                 return (
//                  <div
//                     key={tpl.id}
//                     onClick={() => setSelectedTemplate(tpl)}
//                     className={`group cursor-pointer rounded-2xl border p-4 transition-all duration-200
//                       ${
//                         selectedTemplate?.id === tpl.id
//                           ? "border-blue-600 bg-gradient-to-br from-blue-50 to-indigo-50 shadow-md"
//                           : "border-slate-200 bg-white hover:border-blue-400 hover:bg-blue-50/40 hover:shadow-lg"
//                       }
//                     `}
//                   >
//                     {/* ================= TOP SECTION ================= */}
//                     <div className="flex gap-4">

//                       {/* LEFT : IMAGE + BASIC INFO */}
//                       <div className="flex items-start gap-3 flex-1">

//                         {/* IMAGE with color ring */}
//                         <div className="relative">
//                           <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-500 blur-[6px] opacity-20" />
//                           <div className="relative w-16 h-16 rounded-xl border bg-white flex items-center justify-center overflow-hidden shrink-0">
//                             {product?.image ? (
//                               <img
//                                 src={product.image}
//                                 alt={product.name}
//                                 className="w-full h-full object-contain transition-transform duration-200 group-hover:scale-110"
//                               />
//                             ) : (
//                               <span className="text-xs text-slate-400">No Image</span>
//                             )}
//                           </div>
//                         </div>

//                         {/* INFO */}
//                         <div className="space-y-1">
//                           <h4
//                             className="text-sm font-semibold text-slate-900 capitalize truncate"
//                             title={product?.name}
//                           >
//                             {product?.name || "Warranty Product"}
//                           </h4>

//                           <h5 className="text-sm capitalize truncate">
//                             MRP:{product?.mrp || "Warranty Product"}
//                           </h5>

//                           {/* {category && (
//                             <p className="text-xs text-slate-600">
//                               Category:{" "}
//                               <span className="font-medium text-blue-600">
//                                 {category}
//                               </span>
//                             </p>
//                           )} */}
//                         </div>
//                       </div>

//                       {/* RIGHT : META BOXES */}
//                       <div className="grid grid-cols-2 gap-2 text-center min-w-[170px]">
//                         <div className="rounded-xl bg-emerald-50 border border-emerald-200 p-2">
//                           <p className="text-[11px] text-emerald-600 uppercase tracking-wide">
//                             Validity
//                           </p>
//                           <p className="text-sm font-semibold text-emerald-800">
//                             {product.validity} days
//                           </p>
//                         </div>

//                         <div className="rounded-xl bg-violet-50 border border-violet-200 p-2">
//                           <p className="text-[11px] text-violet-600 uppercase tracking-wide">
//                             Claims
//                           </p>
//                           <p className="text-sm font-semibold text-violet-800">
//                             {product.claims}
//                           </p>
//                         </div>
//                       </div>
//                     </div>

//                     {/* ================= FEATURES SECTION ================= */}
//                     <div className="mt-4 rounded-xl border  px-4 py-3">
//                       <div className="flex items-center gap-2 mb-2">
//                         <span className="inline-block w-2 h-2 rounded-full bg-indigo-500" />
//                         <p className="text-xs font-semibold text-indigo-700 uppercase tracking-wide">
//                           Features
//                         </p>
//                       </div>

//                       {product?.features ? (
//                         <ul className="space-y-1.5">
//                           {product.features
//                             .split(",")
//                             .map((feature, index) => (
//                               <li
//                                 key={index}
//                                 className="flex items-start gap-2 text-sm text-slate-700"
//                               >
//                                 {/* COLORED BULLET */}
//                                 <span className="text-emerald-500 mt-0.5">✔</span>

//                                 {/* FEATURE TEXT */}
//                                 <span className="leading-relaxed">
//                                   {feature.trim()}
//                                 </span>
//                               </li>
//                             ))}
//                         </ul>
//                       ) : (
//                         <p className="text-xs text-slate-400 italic">
//                           No features available
//                         </p>
//                       )}
//                     </div>

// //                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         ) : null}
//       </div>
//     );
//   }

//   /* ================= STEP 2 : CONTACT ================= */
//   /* ================= STEP 2 : DEVICE ================= */
// if (currentStep === 2) {
//   return (
//     <div className="grid grid-cols-2 gap-4">
//       <Input
//         label="Device Brand"
//         value={form.deviceBrand}
//         onChange={(e) => updateField("deviceBrand", e.target.value)}
//         error={errors.deviceBrand}
//       />

//       <Input
//         label="Device Model"
//         value={form.deviceModel}
//         onChange={(e) => updateField("deviceModel", e.target.value)}
//         error={errors.deviceModel}
//       />

//       <Input
//         label="IMEI / Serial No"
//         value={form.deviceImei}
//         onChange={(e) => updateField("deviceImei", e.target.value)}
//         error={errors.deviceImei}
//       />

//       <Input
//         label="MOP (₹)"
//         value={form.devicePrice}
//         disabled
//         error={errors.devicePrice}
//       />
//     </div>
//   );
// }



//   /* ================= STEP 3 : LOCATION ================= */
//   /* ================= STEP 3 : CONTACT + LOCATION ================= */
//   if (currentStep === 3) {
//     return (
//       <div className="space-y-6">

//         {/* -------- CONTACT DETAILS -------- */}
//         <div className="grid grid-cols-3 gap-4">
//           <Input
//             label="Customer Name"
//             value={form.name}
//             disabled={!!existingCustomer}
//             onChange={(e) => updateField("name", e.target.value)}
//             error={errors.name}
//           />

//           <div className="flex flex-col">
//             <Input
//               label="Mobile"
//               value={form.mobile}
//               disabled={!!verifiedMobile || !!existingCustomer}
//               onChange={(e) => updateField("mobile", e.target.value)}
//               error={errors.mobile}
//             />
//           </div>

//           <Input
//             label="Email"
//             value={form.email}
//             onChange={(e) => updateField("email", e.target.value)}
//             error={errors.email}
//           />
//         </div>

//         {/* -------- LOCATION DETAILS -------- */}
//         <div className="grid grid-cols-3 gap-4">
//           <div className="flex flex-col">
//             <Input
//               label="Pincode"
//               value={form.pincode}
//               onChange={(e) => {
//                 const value = e.target.value.replace(/\D/g, "");
//                 updateField("pincode", value);

//                 if (value.length < 6) {
//                   updateField("state", "");
//                   updateField("city", "");
//                   updateField("location", "");
//                 }

//                 if (value.length === 6) {
//                   onPincodeChange(value);
//                 }
//               }}
//               error={errors.pincode}
//             />

//             {pinLoading && (
//               <span className="mt-1 text-xs text-slate-500">
//                 Fetching location…
//               </span>
//             )}
//           </div>

//           <Input label="State" value={form.state} disabled error={errors.state} />
//           <Input label="City" value={form.city} disabled error={errors.city} />
//           <Input
//             label="Location"
//             value={form.location}
//             onChange={(e) => updateField("location", e.target.value)}
//             error={errors.location}
//           />
//         </div>

//       </div>
//     );
//   }




//   /* ================= STEP 4 : DEVICE ================= */
//   if (currentStep === 4) {
//     return (
//       <div className="grid grid-cols-2 gap-4">
//         <Input
//           label="Device Brand"
//           value={form.deviceBrand}
//           onChange={(e) => updateField("deviceBrand", e.target.value)}
//           error={errors.deviceBrand}
//         />
//         <Input
//           label="Device Model"
//           value={form.deviceModel}
//           onChange={(e) => updateField("deviceModel", e.target.value)}
//           error={errors.deviceModel}
//         />
//         <Input
//           label="IMEI / Serial No"
//           value={form.deviceImei}
//           onChange={(e) => updateField("deviceImei", e.target.value)}
//           error={errors.deviceImei}
//         />
//         <Input
//           label="MOP (₹)"
//           value={form.devicePrice}
//           disabled
//           error={errors.devicePrice}
//         />

//       </div>
//     );
//   }

//   /* ================= STEP 5 : PAYMENT ================= */
//   if (currentStep === 5) {
//     return (
//       <div className="space-y-4">

//         <h3 className="text-sm font-semibold text-slate-800">
//           Choose Payment Option
//         </h3>

//         <div className="grid grid-cols-2 gap-4">
//           {/* PAY NOW */}
//           <div
//             onClick={() => updateField("paymentMode", "pay_now")}
//             className={`cursor-pointer rounded-xl border p-4 transition
//               ${
//                 form.paymentMode === "pay_now"
//                   ? "border-blue-600 bg-blue-50"
//                   : "border-slate-200 hover:border-blue-400"
//               }
//             `}
//           >
//             <h4 className="text-sm font-semibold text-slate-900">
//               Pay Now
//             </h4>
//             <p className="text-xs text-slate-500 mt-1">
//               Complete payment immediately
//             </p>
//           </div>

//           {/* PAY LATER */}
//           <div
//             onClick={() => updateField("paymentMode", "pay_later")}
//             className={`cursor-pointer rounded-xl border p-4 transition
//               ${
//                 form.paymentMode === "pay_later"
//                   ? "border-blue-600 bg-blue-50"
//                   : "border-slate-200 hover:border-blue-400"
//               }
//             `}
//           >
//             <h4 className="text-sm font-semibold text-slate-900">
//               Pay Later
//             </h4>
//             <p className="text-xs text-slate-500 mt-1">
//               Payment will be collected later
//             </p>
//           </div>
//         </div>

//         {errors.paymentMode && (
//           <p className="text-xs text-red-500">
//             {errors.paymentMode}
//           </p>
//         )}
//       </div>
//     );
//   }


//   return null;
// };



// import RegularLoader from "../../../../Component/Loader/RegularLoader";
// import { Input } from "./Input";

// /* ===============================
//    FORM BODY
// ================================ */
// export const FormBody = ({
//   currentStep,
//   form,
//   errors,
//   updateField,
//   existingCustomer,

//   categories = [],
//   priceTemplates = [],
//   selectedTemplate,
//   setSelectedTemplate,
//   loading = false,

//   onViewTemplates, // ✅ NEW
//   onPincodeChange,
//   pinLoading,


// }) => {
  


//   /* ================= STEP 1 : PRICING ================= */
  
// if (currentStep === 1) {
//   return (
//     <div className="space-y-6">

//       {/* CATEGORY + PRICE */}
//       <div className="grid grid-cols-2 gap-4">
//         <div>
//           <label className="text-sm font-medium text-slate-700">
//             Category
//           </label>
//           <select
//             value={form.category}
//             onChange={(e) => updateField("category", e.target.value)}
//             className="mt-1 w-64 px-3 py-2 border rounded-lg text-sm"
//           >
//             <option value="">Select Category</option>
//             {categories.map((cat) => (
//               <option key={cat.id} value={cat.id}>
//                 {cat.name}
//               </option>
//             ))}
//           </select>
//         </div>

//         <Input
//           label="MOP Price (₹)"
//           value={form.mopPrice}
//           onChange={(e) => updateField("mopPrice", e.target.value)}
//           error={errors.mopPrice}
//           type="number"
//         />
//       </div>

//       {/* BUTTON */}
//       <button
//         onClick={onViewTemplates}
//         disabled={loading}
//         className="px-6 py-2 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 disabled:opacity-50"
//       >
//         {loading ? "Loading..." : "View Templates"}
//       </button>

//       {/* TEMPLATES */}
//       {loading ? (
//         <RegularLoader />
//       ) : priceTemplates.length > 0 ? (
//         <div>
//           <h3 className="text-sm font-semibold mb-3">
//             Select Price Template
//           </h3>

//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
//             {priceTemplates.map((tpl) => {
//               const product = tpl.warranty_product;
//               const category = product?.categories?.[0]?.name;

//               return (
//                 <div
//                   key={tpl.id}
//                   onClick={() => setSelectedTemplate(tpl)}
//                   className={`group cursor-pointer rounded-xl border p-4 transition shadow-lg
//                     ${
//                       selectedTemplate?.id === tpl.id
//                         ? "border-blue-600 bg-blue-50 shadow-md"
//                         : "border-slate-200 hover:border-blue-400 hover:bg-blue-50/40"
//                     }
//                   `}
//                 >
//                   {/* HEADER */}
//                   <div className="flex items-start gap-3">
                    
//                     {/* PRODUCT IMAGE */}
//                     <div className="w-14 h-14 rounded-lg border bg-white flex items-center justify-center overflow-hidden">
//                       {product?.image ? (
//                         <img
//                           src={product.image}
//                           alt={product.name}
//                           className="w-full h-full object-contain transition-transform group-hover:scale-105"
//                         />
//                       ) : (
//                         <span className="text-xs text-slate-400">
//                           No Image
//                         </span>
//                       )}
//                     </div>

//                     {/* PRODUCT INFO */}
//                     <div className="flex-1">
//                       <h4 className="text-sm font-semibold text-slate-900 capitalize">
//                         {product?.name || "Warranty Product"}
//                       </h4>

//                       {category && (
//                         <p className="text-xs text-slate-500 mt-0.5">
//                           Category: {category}
//                         </p>
//                       )}

//                       {category && (
//                         <p className="text-xs text-slate-500 mt-0.5">
//                           Features: {product.features}
//                         </p>
//                       )}
//                     </div>

//                     {/* TYPE BADGE */}
//                     <span
//                       className={`text-[11px] font-semibold px-2 py-0.5 rounded-full border
//                         ${
//                           tpl.is_fixed
//                             ? "bg-emerald-50 text-emerald-700 border-emerald-200"
//                             : "bg-indigo-50 text-indigo-700 border-indigo-200"
//                         }
//                       `}
//                     >
//                       {tpl.is_fixed ? "Fixed" : "Percent"}
//                     </span>
//                     <span
//                       className={`text-[11px] font-semibold px-2 py-0.5 rounded-full border
//                         ${
//                           product.status
//                             ? "bg-emerald-50 text-emerald-700 border-emerald-200"
//                             : "bg-indigo-50 text-red-700 border-red-200"
//                         }
//                       `}
//                     >
//                       {product.status === 1 ? "Active" : "Inactive"}
//                     </span>
//                   </div>

//                   {/* PRICE RANGE */}
//                   <div className="mt-3 rounded-lg bg-slate-50 border px-3 py-2">
//                     <p className="text-xs text-slate-500">
//                       Applicable Price Range
//                     </p>
//                     <p className="text-sm font-semibold text-slate-900">
//                       ₹{tpl.min_price.toLocaleString()} – ₹{tpl.max_price.toLocaleString()}
//                     </p>
//                   </div>

//                   {/* PAYOUTS */}
//                   <div className="mt-3 grid grid-cols-2 gap-2 text-center">
//                     <div className="rounded-lg bg-white border p-2">
//                       <p className="text-[11px] text-slate-500">Validity</p>
//                       <p className="text-sm font-semibold text-slate-800">
//                         {product.validity} day
//                       </p>
//                     </div>

//                     <div className="rounded-lg bg-white border p-2">
//                       <p className="text-[11px] text-slate-500">Claims</p>
//                       <p className="text-sm font-semibold text-slate-800">
//                         {product.claims}
//                       </p>
//                     </div>

//                     {/* <div className="rounded-lg bg-white border p-2">
//                       <p className="text-[11px] text-slate-500">Other</p>
//                       <p className="text-sm font-semibold text-slate-800">
//                         ₹{tpl.other_payout}
//                       </p>
//                     </div> */}
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       ) : null}
//     </div>
//   );
// }


//   /* ================= STEP 2 : CONTACT ================= */
//   if (currentStep === 2) {
//     return (
//       <div className="grid grid-cols-3 gap-4">
//         <Input
//           label="Mobile"
//           value={form.mobile}
//           disabled={!!existingCustomer}
//           onChange={(e) => updateField("mobile", e.target.value)}
//           error={errors.mobile}
//         />

//         {/* <Input
//           label="Mobile"
//           value={form.mobile}
//           onChange={(e) => updateField("mobile", e.target.value)}
//           error={errors.mobile}
//         /> */}
//         <Input
//           label="Email"
//           value={form.email}
//           onChange={(e) => updateField("email", e.target.value)}
//           error={errors.email}
//         />
//       </div>
//     );
//   }

//   /* ================= STEP 3 : LOCATION ================= */
//   if (currentStep === 3) {
//   return (
//     <div className="grid grid-cols-3 gap-4">

//       {/* PINCODE */}
//       <div className="flex flex-col">
//         <Input
//           label="Pincode"
//           value={form.pincode}
//           onChange={(e) => {
//             const value = e.target.value.replace(/\D/g, "");
//             updateField("pincode", value);

//             // 🔁 Clear auto-filled fields if pincode is incomplete
//             if (value.length < 6) {
//               updateField("state", "");
//               updateField("city", "");
//               updateField("location", "");
//             }

//             // 🚀 Fetch location only at exactly 6 digits
//             if (value.length === 6) {
//               onPincodeChange(value);
//             }
//           }}
//           error={errors.pincode}
//         />

//         {pinLoading && (
//           <span className="mt-1 text-xs text-slate-500">
//             Fetching location…
//           </span>
//         )}
//       </div>

//       {/* STATE */}
//       <Input
//         label="State"
//         value={form.state}
//         disabled
//         error={errors.state}
//       />

//       {/* CITY */}
//       <Input
//         label="City"
//         value={form.city}
//         disabled
//         error={errors.city}
//       />

//       {/* LOCATION */}
//       <Input
//         label="Location"
//         value={form.location}
//         onChange={(e) => updateField("location", e.target.value)}
//         error={errors.location}
//       />
//     </div>
//   );
// }



//   /* ================= STEP 4 : DEVICE ================= */
//   if (currentStep === 4) {
//     return (
//       <div className="grid grid-cols-2 gap-4">
//         <Input
//           label="Device Brand"
//           value={form.deviceBrand}
//           onChange={(e) => updateField("deviceBrand", e.target.value)}
//           error={errors.deviceBrand}
//         />
//         <Input
//           label="Device Model"
//           value={form.deviceModel}
//           onChange={(e) => updateField("deviceModel", e.target.value)}
//           error={errors.deviceModel}
//         />
//         <Input
//           label="IMEI / Serial No"
//           value={form.deviceImei}
//           onChange={(e) => updateField("deviceImei", e.target.value)}
//           error={errors.deviceImei}
//         />
//         <Input
//           label="MOP (₹)"
//           value={form.devicePrice}
//           onChange={(e) => updateField("devicePrice", e.target.value)}
//           error={errors.devicePrice}
//         />
//       </div>
//     );
//   }

//   /* ================= STEP 5 : PAYMENT ================= */
//   if (currentStep === 5) {
//     return (
//       <div className="space-y-4">

//         <h3 className="text-sm font-semibold text-slate-800">
//           Choose Payment Option
//         </h3>

//         <div className="grid grid-cols-2 gap-4">
//           {/* PAY NOW */}
//           <div
//             onClick={() => updateField("paymentMode", "pay_now")}
//             className={`cursor-pointer rounded-xl border p-4 transition
//               ${
//                 form.paymentMode === "pay_now"
//                   ? "border-blue-600 bg-blue-50"
//                   : "border-slate-200 hover:border-blue-400"
//               }
//             `}
//           >
//             <h4 className="text-sm font-semibold text-slate-900">
//               Pay Now
//             </h4>
//             <p className="text-xs text-slate-500 mt-1">
//               Complete payment immediately
//             </p>
//           </div>

//           {/* PAY LATER */}
//           <div
//             onClick={() => updateField("paymentMode", "pay_later")}
//             className={`cursor-pointer rounded-xl border p-4 transition
//               ${
//                 form.paymentMode === "pay_later"
//                   ? "border-blue-600 bg-blue-50"
//                   : "border-slate-200 hover:border-blue-400"
//               }
//             `}
//           >
//             <h4 className="text-sm font-semibold text-slate-900">
//               Pay Later
//             </h4>
//             <p className="text-xs text-slate-500 mt-1">
//               Payment will be collected later
//             </p>
//           </div>
//         </div>

//         {errors.paymentMode && (
//           <p className="text-xs text-red-500">
//             {errors.paymentMode}
//           </p>
//         )}
//       </div>
//     );
//   }

//   return null;
// };
